/* assets/sx-vehicle-finder-nz.js
   Vehicle finder + rego lookup for the NZ market Vehicle Strut Store.

   This code used to live inline in the custom_liquid setting of section
   custom_liquid_LxBeGY in templates/page.vehicle-strut-store.context.nz.json.
   That setting hit Shopify's hard 50 KB per-setting Liquid limit, which made
   the WHOLE template file fail to sync from GitHub - silently, so the NZ
   storefront sat on the 23 August version for days. Moving it here removes
   the ceiling.

   The two Liquid values it needs are set by the section just before this
   file loads:
     window.SX_FALLBACK_IMG  - gas-strut-hero.png asset url
     window.SX_GROUPS_URL    - sx-vehicle-groups.json asset url
*/
(function(){
'use strict';
window.SX_VF = {
make: null,
mod: null,
regoFilter: null,
plate: null,
regoInProgress: false
};
var SX_VD = {};
var SX_MAKES = [];
var SX_DATA_BASE = 'https://struxa-data-nz.vercel.app/';
/* Bump this when a struxa-data-nz change must reach already-cached
   browsers immediately instead of within the day. */
var SX_DATA_VER = '1';
/* One token per UTC day, matching the host's max-age=86400. */
function sxDataToken(){return SX_DATA_VER+'-'+Math.floor(Date.now()/86400000);}
var SX_FALLBACK_IMG = window.SX_FALLBACK_IMG;
var SX_PROD_BASE = '/pages/contact';
var SX_OE_API = 'https://struxa-api-xp26.vercel.app/api/oe-match';
/* Struxa's own endpoint, not the shared carjam-proxy. That proxy belongs to
   the other business and is left alone; this simply stops depending on it.
   api/rego validates the plate before spending, caches so a repeated plate is
   free, strips the 40 fields the finder never reads (odometer, owner count,
   WOF/COF history, reported-stolen) and handles CarJam's async null itself. */
var SX_CARJAM_PROXY = 'https://struxa-api-xp26.vercel.app/api/rego';
window.SX_CLAUDE_PROXY = 'https://struxa-api-xp26.vercel.app/api/claude-proxy';
window.SX_CATALOGUE_URL= 'https://struxa-api-xp26.vercel.app/api/catalogue';
var SX_SKU_CACHE={};
function sxResolveSku(sku,cb){if(!sku){cb(null);return;}if(SX_SKU_CACHE.hasOwnProperty(sku)){cb(SX_SKU_CACHE[sku]);return;}fetch('/search/suggest.json?q='+encodeURIComponent(sku)+'&resources[type]=product&resources[limit]=1&resources[options][fields]=variants.sku,title').then(function(r){return r.json();}).then(function(d){var p=d.resources&&d.resources.results&&d.resources.results.products&&d.resources.results.products[0];var res=p?{url:'/products/'+p.handle,img:p.featured_image?p.featured_image.url:null,price:p.price}:null;SX_SKU_CACHE[sku]=res;cb(res);}).catch(function(){SX_SKU_CACHE[sku]=null;cb(null);});}
window.__sxRS=sxResolveSku;window.__sxVD=function(){return SX_VD;};
var SX_VIRTUAL_MAKES = {
/* Glas-Tek, Suspa and Ferrari were listed here but have no products and no
   data file, so they only ever inflated the tile count. Removed. */
"Canopy": ["Arb","Back","Crown","Taylor","Tuff"],
"Other": ["Chrysler","Daewoo","Daihatsu","Explorer","Lada","Lotus","Pontiac","Rexton","Saab","Smart","SsangYong"]
};
var SX_SUPPRESS_MAKES = {};
Object.keys(SX_VIRTUAL_MAKES).forEach(function(vm){
SX_VIRTUAL_MAKES[vm].forEach(function(src){ SX_SUPPRESS_MAKES[src] = vm; });
});
var SX_MERGE_INTO = { "Explorer": "Ford" };
var SX_GROUPS = {};
(function(){var xhr=new XMLHttpRequest();xhr.open('GET',window.SX_GROUPS_URL,true);xhr.onload=function(){if(xhr.status===200){try{SX_GROUPS=JSON.parse(xhr.responseText);}catch(e){}}};xhr.send();})();
function sxGetGroups(make){
var k=Object.keys(SX_GROUPS).find(function(g){return g.toLowerCase()===make.toLowerCase();});
return k?SX_GROUPS[k]:{};
}
/* Struxa: a virtual make ("Canopy", "Other") copies its sources in under
   composite keys - "Arb - Canopy", "Back - Pack Canopy". The model list then
   collapses each source's keys into one row labelled with the source name, so
   the row for Arb asks for member "Arb" - a key that does not exist. Result:
   Arb, Back and Taylor all returned 0 products, while Crown and Tuff worked
   only because they have a single model and so were never grouped.

   So resolve each member against the real keys: exact match first, then any
   key beginning "<member> - ". Real makes are unaffected - their keys are
   plain model names and hit the exact branch. */
function sxGroupProducts(make,groupBase){
var groups=sxGetGroups(make);
var members=groups[groupBase]||[groupBase];
var bag=SX_VD[make]||{};
var all=[];
members.forEach(function(m){
if(Array.isArray(bag[m])){all=all.concat(bag[m]);return;}
var pre=m+' \u2014 ';
Object.keys(bag).forEach(function(k){if(Array.isArray(bag[k])&&k.indexOf(pre)===0)all=all.concat(bag[k]);});
});
return all;
}
function sxNorm(s){return(s||'').toLowerCase().replace(/[\s\-_]/g,'');}
/* The model's own number - the digits attached to the leading letters, or
   a standalone leading number. 'CX-5'->5, 'A4 Avant'->4, '6 Estate'->6,
   'Delica'->null. Trim levels later in the name are not the model number,
   so 'A6 Allroad C7' is 6, not 7. */
function sxModelNum(s){var n=sxNorm(s);var m=n.match(/^[a-z]*(\d+)/);return m?m[1]:null;}
function sxFuzzyModels(mk,rawModel){
if(!SX_VD[mk]||!rawModel)return[];
var allMods=Object.keys(SX_VD[mk]).filter(function(m){return m!=='_misc'&&m!=='_loaded'&&m!=='_count';});
function sigWords(s){return s.toLowerCase().replace(/[^a-z0-9]/g,' ').split(/\s+/).filter(function(w){return w.length>1;});}
var queryWords=sigWords(rawModel),normQuery=sxNorm(rawModel);
if(queryWords.length>0){
var tier1=allMods.filter(function(m){var mw=sigWords(m);return queryWords.every(function(qw){return mw.some(function(kw){return kw===qw||kw.indexOf(qw)===0||(qw.indexOf(kw)===0&&kw.length>=3);});});});
if(tier1.length)return tier1;
}
var tier2=allMods.filter(function(m){var nm=sxNorm(m);return nm.length>=3&&(nm.indexOf(normQuery)===0||normQuery.indexOf(nm)===0);});
if(tier2.length)return tier2;
return allMods.filter(function(m){var mw=m.toLowerCase().replace(/[^a-z0-9]/g,' ').split(/\s+/).filter(function(w){return w.length>1;});return queryWords.some(function(qw){return qw.length>2&&mw.some(function(kw){return kw.indexOf(qw)===0||qw.indexOf(kw)===0;});});});
}
function sxSlug(t){return t.toLowerCase().replace(/\./g,'-').replace(/[()\[\]\/\\]/g,' ').replace(/[^a-z0-9\s-]/g,'').replace(/\s+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');}
function sxFixUrl(url){if(!url)return url;return url.replace(/([^\w]|^)(\d)(\d)([a-z])/g,function(m,pre,a,b,c){return pre+a+'-'+b+c;});}
function sxProductStartYear(title){
if(!title)return 0;
function exp(n){n=parseInt(n);return n<=99?(n<=30?2000+n:1900+n):n;}
var r4=title.match(/(\d{4})\s*[-\u2013]\s*(\d{4})/);if(r4)return parseInt(r4[2]);
var rm=title.match(/(\d{4})\s*-\s*(\d{2})(?!\d)/);if(rm)return exp(rm[2]);
var fon=title.match(/(\d{4})\s*[+>]/);if(fon)return parseInt(fon[1]);
var s4=title.match(/\((\d{4})\)/);if(s4)return parseInt(s4[1]);
var any4=title.match(/(\d{4})/);if(any4)return parseInt(any4[1]);
return 0;
}
/* ------------------------------------------------------------------
   ONE STRUT, ONE CARD. Dave, 14/09/2026: "if I search a rego like this and it
   has 2 struts similar years same length can you just remove one or something?
   it confuses the customer".

   An Audi A3 search returned "Audi A3 2012-2020 (Boot) (540mm)" and "Audi A3
   Sportback 2013-2020 (Boot) (540mm)". Same 540mm, same 460N, same 215 stroke,
   same H6/H6 ends, same $75 - one part, listed twice under two fitment names.

   WHY THIS READS A SPEC FILE INSTEAD OF THE CARD. Two things make the obvious
   version wrong:

     - most titles do not print the force rating, so "same name, same length"
       would merge the A3's 410N and 460N boot struts, which are different
       parts. Hiding one on pressure is the precise failure Fit Assurance is
       there to prevent.
     - the same part is shared across unrelated vehicles (that 500mm bonnet
       strut is listed for an Audi A3, a VW Bora and seven others), so a
       catalogue-wide merge would delete a Bora owner's only listing.

   So it fingerprints on the authoritative spec - length, force, stroke, end
   fittings, shaft - and is only ever applied to a list that has ALREADY been
   filtered to one vehicle. Same car, same part = one card.

   It fails open. No spec file, no SKU, no fingerprint: the product is kept.
   A missing asset must never make a strut disappear.
   ------------------------------------------------------------------ */
var SX_PART_SPEC = null;
(function(){
  var url = (window.SX_PART_SPEC_URL || '');
  if (!url || !window.fetch) return;
  fetch(url).then(function(r){ return r.json(); })
            .then(function(j){ SX_PART_SPEC = j || null; })
            .catch(function(){ SX_PART_SPEC = null; });
})();

function sxDedupeSamePart(items, wantYear){
  if (!SX_PART_SPEC || !items || items.length < 2) return items || [];
  var best = {}, order = [];
  for (var i = 0; i < items.length; i++) {
    var p = items[i];
    var fp = p && p.s ? SX_PART_SPEC[p.s] : null;
    if (!fp) { order.push(p); continue; }          // unknown part - always keep
    if (!best.hasOwnProperty(fp)) { best[fp] = p; order.push(fp); continue; }
    best[fp] = sxPreferListing(best[fp], p, wantYear);
  }
  var out = [];
  for (var j = 0; j < order.length; j++) {
    var k = order[j];
    out.push(typeof k === 'string' ? best[k] : k);
  }
  return out;
}

/* Which of two listings for the same part to show. The one whose years cover
   the customer's car wins; if both do or neither does, the wider range wins,
   because it is the more general fitment name. */
function sxPreferListing(a, b, wantYear){
  var y = parseInt(wantYear, 10) || 0;
  var ra = sxGetYearRange(a.t), rb = sxGetYearRange(b.t);
  if (y) {
    var ina = (y >= ra.s && y <= ra.e), inb = (y >= rb.s && y <= rb.e);
    if (ina !== inb) return ina ? a : b;
  }
  return ((ra.e - ra.s) >= (rb.e - rb.s)) ? a : b;
}

function sxGetYearRange(title){
if(!title)return{s:0,e:9999};
function exp(n){n=parseInt(n);return n<=99?(n<=30?2000+n:1900+n):n;}
var r4=title.match(/(\d{4})\s*[-\u2013]\s*(\d{4})/);if(r4)return{s:parseInt(r4[1]),e:parseInt(r4[2])};
var rm=title.match(/(\d{4})\s*-\s*(\d{2})(?!\d)/);if(rm)return{s:parseInt(rm[1]),e:exp(rm[2])};
var r2=title.match(/\b(\d{2})\s*-\s*(\d{2})(?!\d)/);if(r2){var s=exp(r2[1]),e=exp(r2[2]);if(e>=s)return{s:s,e:e};}
var fon4=title.match(/(\d{4})\s*[+>]/);if(fon4)return{s:parseInt(fon4[1]),e:9999};
var fon2a=title.match(/\((\d{2})-\)/);if(fon2a)return{s:exp(fon2a[1]),e:9999};
var fon2b=title.match(/\b(\d{2})-(?!\d)/);if(fon2b)return{s:exp(fon2b[1]),e:9999};
var s4=title.match(/\((\d{4})\)/);if(s4)return{s:parseInt(s4[1]),e:parseInt(s4[1])};
var any4=title.match(/\b(\d{4})\b/);if(any4)return{s:parseInt(any4[1]),e:parseInt(any4[1])};
return{s:0,e:9999};
}
function sxRegoSortScore(title,carYear){
var y=parseInt(carYear)||0;if(!y)return-sxProductStartYear(title);
var r=sxGetYearRange(title);var width=(r.e===9999?50:r.e-r.s)||1;
if(y>=r.s&&y<=r.e)return width;
var dist=Math.min(Math.abs(y-r.s),Math.abs(y-r.e));return 10000+dist;
}
/* Struxa: the catalogue stores titles with the year LAST -
   "Audi 100 C3 Avant (Boot) (580mm) (1982-1990)" - and Dave wants the year to
   read straight after the vehicle, matching how the Shopify product titles are
   being reordered. This is DISPLAY ONLY: p.t is untouched, so every match,
   filter and year-label parse below still sees the original string.

   Deliberately written without regular expressions. Everything here is scanned
   with indexOf and charAt so the file stays free of escape sequences, which
   have been mangled in transit through the commit tooling more than once.

   Same rule as the product retitle: the year group moves in front of the first
   bracketed group, and in front of a trailing location word when the location
   is not bracketed ("Audi A4 Bonnet (280mm) (1999)" -> "Audi A4 (1999) Bonnet
   (280mm)"). */
function sxYearFirst(t){
if(!t||typeof t!=='string')return t;
function isYear(s){
s=s.trim();
if(s.length<4)return false;
for(var k=0;k<4;k++){var c=s.charAt(k);if(c<'0'||c>'9')return false;}
if(s.length===4)return true;
var rest=s.slice(4).trim();
if(rest.charAt(0)!=='-')return false;
rest=rest.slice(1).trim().toLowerCase();
if(rest==='present')return true;
if(rest.length!==4)return false;
for(var j=0;j<4;j++){var d=rest.charAt(j);if(d<'0'||d>'9')return false;}
return true;
}
var groups=[],i=0;
while(true){
var a=t.indexOf('(',i);if(a<0)break;
var b=t.indexOf(')',a);if(b<0)break;
groups.push({a:a,b:b,txt:t.slice(a,b+1),inner:t.slice(a+1,b)});
i=b+1;
}
if(groups.length<2)return t;
var yi=-1;
for(var g=0;g<groups.length;g++){if(isYear(groups[g].inner)){yi=g;break;}}
if(yi<=0)return t;
var year=groups[yi].txt;
var out=(t.slice(0,groups[yi].a)+t.slice(groups[yi].b+1));
while(out.indexOf('  ')>-1)out=out.split('  ').join(' ');
out=out.trim();
var first=out.indexOf('(');
if(first<0)return t;
var head=out.slice(0,first).trim(),tail=out.slice(first);
var LOCS=['Rear Window','Back Door','Side Door','B/Door','Tailgate','Bonnet','Window','Canopy','Hatch','Trunk','Boot','Hood','Door'];
for(var L=0;L<LOCS.length;L++){
var w=LOCS[L];
if(head.length>w.length+1&&head.slice(head.length-w.length).toLowerCase()===w.toLowerCase()&&head.charAt(head.length-w.length-1)===' '){
return (head.slice(0,head.length-w.length).trim()+' '+year+' '+w+' '+tail).trim();
}
}
return (head+' '+year+' '+tail).trim();
}
function sxExtractYearLabel(title){
if(!title)return null;
function exp(n){n=parseInt(n);return n<=99?(n<=30?2000+n:1900+n):n;}
var r4=title.match(/(\d{4})\s*[-\u2013]\s*(\d{4})/);if(r4)return r4[1]+'\u2013'+r4[2];
var rm=title.match(/(\d{4})\s*-\s*(\d{2})(?!\d)/);if(rm)return rm[1]+'\u2013'+exp(rm[2]);
var rm2=title.match(/(\d{2})\s*-\s*(\d{4})/);if(rm2)return exp(rm2[1])+'\u2013'+rm2[2];
var fplus=title.match(/(\d{4})\s*[+>]/);if(fplus)return fplus[1]+' on';
var f2p=title.match(/\((\d{2})-\)/);if(f2p)return exp(f2p[1])+' on';
var f2b=title.match(/\b(\d{2})-(?!\d)/);if(f2b)return exp(f2b[1])+' on';
var r2=title.match(/\b(\d{2})\s*[-\u2013]\s*(\d{2})\b(?!\d)/);if(r2)return exp(r2[1])+'\u2013'+exp(r2[2]);
var s4=title.match(/\((\d{4})\)/);if(s4)return s4[1];
return null;
}
function sxExtractYearTag(title){
if(!title)return null;
function exp(n){n=parseInt(n);return n<=99?(n<=30?2000+n:1900+n):n;}
var r4=title.match(/(\d{4})\s*[-\u2013]\s*(\d{4})/);if(r4)return r4[1]+'\u2013'+r4[2];
var rm=title.match(/(\d{4})\s*-\s*(\d{2})(?!\d)/);if(rm)return rm[1]+'\u2013'+exp(rm[2]);
var fplus4=title.match(/(\d{4})\s*[+>]/);if(fplus4)return fplus4[1]+'+';
var s4=title.match(/\((\d{4})\)/);if(s4)return s4[1];
var r2=title.match(/\b(\d{2})\s*-\s*(\d{2})(?!\d)/);if(r2)return exp(r2[1])+'\u2013'+exp(r2[2]);
var fon2a=title.match(/\((\d{2})-\)/);if(fon2a)return exp(fon2a[1])+'+';
var fon2b=title.match(/\b(\d{2})-(?!\d)/);if(fon2b)return exp(fon2b[1])+'+';
var any4=title.match(/\b(\d{4})\b/);if(any4)return any4[1];
return null;
}
function sxLabelCoversYear(label,year){
if(!label||!year)return false;var y=parseInt(year);
var fon=label.match(/^(\d{4}) on$/);if(fon&&y>=parseInt(fon[1]))return true;
var frng=label.match(/^(\d{4})[^\d](\d{4})$/);if(frng&&y>=parseInt(frng[1])&&y<=parseInt(frng[2]))return true;
if(label===String(year))return true;return false;
}
function sxFilterByLabelWithRanges(allProds,label){
if(!label)return{exact:allProds,inRange:[]};
var clickedStart=null,clickedEnd=null;
var rng=label.match(/^(\d{4})[^\d](\d{4})$/);if(rng){clickedStart=parseInt(rng[1]);clickedEnd=parseInt(rng[2]);}
var fon=label.match(/^(\d{4}) on$/);if(fon){clickedStart=parseInt(fon[1]);clickedEnd=9999;}
var ex1=label.match(/^(\d{4})$/);if(ex1){clickedStart=parseInt(ex1[1]);clickedEnd=parseInt(ex1[1]);}
var exact=[],inRange=[];
allProds.forEach(function(p){
var pl=sxExtractYearLabel(p.t);
if(pl===label){exact.push(p);return;}
if(clickedStart!==null&&pl){
var plEx=pl.match(/^(\d{4})$/);if(plEx){var py=parseInt(plEx[1]);if(py>=clickedStart&&py<=clickedEnd){exact.push(p);return;}}
if(sxLabelCoversYear(pl,clickedStart)){inRange.push(p);return;}
}
});
return{exact:exact,inRange:inRange};
}
function sxStatusShow(msg){
var el=document.getElementById('sx-rego-status');if(!el)return;
el.innerHTML='<span class="sx-pulse-dot"></span>'+msg;el.classList.add('sx-show');
}
function sxStatusHide(){
var el=document.getElementById('sx-rego-status');if(!el)return;
el.innerHTML='';el.classList.remove('sx-show');
}
function sxPanel(id){
if(!window.SX_VF.regoInProgress)sxStatusHide();
['pp','pm','pr'].forEach(function(p){
var el=document.getElementById('sx-'+p);
if(el)el.classList[p===id?'add':'remove']('sx-on');
});
var nav=document.getElementById('sx-nav-bar');if(!nav)return;
if(id==='pp'){nav.classList.remove('sx-show');}
else{
nav.classList.add('sx-show');
var backBtn=document.getElementById('sx-nav-back-btn');
if(backBtn){backBtn.textContent=id==='pm'?'← Back to Makes':'← Back to Models';}
}
}
window.sxVfSwitchTab=function(tab){
var regoPanel = document.getElementById('sx-rego-panel');
var modelPanel = document.getElementById('sx-model-panel');
var scanPanel = document.getElementById('sx-scan-panel');
var regoTab = document.getElementById('sx-tab-rego');
var modelTab = document.getElementById('sx-tab-model');
var scanTab = document.getElementById('sx-tab-scan');
if(regoPanel) regoPanel.style.display = (tab==='rego' ? '' : 'none');
if(modelPanel) modelPanel.style.display = (tab==='model' ? '' : 'none');
if(scanPanel) scanPanel.style.display = (tab==='scan' ? '' : 'none');
if(regoTab) regoTab.classList.toggle('sx-active', tab==='rego');
if(modelTab) modelTab.classList.toggle('sx-active', tab==='model');
if(scanTab) scanTab.classList.toggle('sx-active', tab==='scan');
document.getElementById('sx-rego-hint').textContent='';
var vi=document.getElementById('sx-vehicle-badge');if(vi)vi.remove();
var nf=document.getElementById('sx-not-found');if(nf)nf.remove();
if(tab==='scan'){if(typeof sxScLoadCatalogue==='function')sxScLoadCatalogue();if(typeof sxScStopCam==='function')sxScStopCam();return;}
if(typeof sxScStopCam==='function')sxScStopCam();
if(tab==='model'||tab==='rego'){
var ri=document.getElementById('sx-rego-inp');if(ri)ri.value='';
var mi=document.getElementById('sx-model-inp');if(mi)mi.value='';
SX_VF.plate=null;
}
if(tab==='model'){sxRenderMakes();sxPanel('pp');}
};
function sxRenderMakes(filter){
var ft=(filter||'').toLowerCase();
var grid=document.getElementById('sx-makes-grid');
var label=document.getElementById('sx-makes-label');
if(!grid)return;
grid.innerHTML='';
var displayMakes=[];
SX_MAKES.forEach(function(mk){
if(SX_SUPPRESS_MAKES[mk]||SX_MERGE_INTO[mk])return;
displayMakes.push({name:mk,virtual:false});
});
Object.keys(SX_VIRTUAL_MAKES).sort().forEach(function(vm){displayMakes.push({name:vm,virtual:true});});
displayMakes.sort(function(a,b){if(a.name==='Other')return 1;if(b.name==='Other')return -1;return a.name.localeCompare(b.name);});
var n=0;
displayMakes.forEach(function(entry){
var mk=entry.name;
if(ft&&mk.toLowerCase().indexOf(ft)<0)return;
var count;
if(entry.virtual){count=SX_VIRTUAL_MAKES[mk].reduce(function(sum,src){if(!SX_VD[src])return sum;return sum+(SX_VD[src]._loaded?Object.values(SX_VD[src]).filter(function(v){return Array.isArray(v);}).reduce(function(a,b){return a+b.length;},0):(SX_VD[src]._count||0));},0);}
else{count=SX_VD[mk]?(SX_VD[mk]._loaded?Object.values(SX_VD[mk]).filter(function(v){return Array.isArray(v);}).reduce(function(a,b){return a+b.length;},0):(SX_VD[mk]._count||0)):0;}
var d=document.createElement('div');d.className='sx-make-card';
d.innerHTML='<span class="sx-make-card-bar"></span><div class="sx-make-card-inner"><span class="sx-make-name">'+mk+'</span><span class="sx-make-count">'+count+(count===1?' product':' products')+'</span><span class="sx-make-arrow">▶</span></div>';
d.addEventListener('click',(function(m,iv){return function(){sxVfPickMake(m,iv);};})(mk,entry.virtual));
grid.appendChild(d);n++;
});
if(label)label.textContent=SX_MAKES.length?SX_MAKES.length+' Makes':'Makes';
if(!n&&filter)grid.innerHTML='<div style="padding:16px;color:var(--muted);text-align:center">No results for "'+filter+'"<br><br>'+sxDeadEndText('')+sxDeadEndActions(SX_SCROLL_TO_CONTACT)+'</div>';
}
window.sxVfPickMake=function(mk,isVirtual){
SX_VF.mod=null;
if(isVirtual||SX_VIRTUAL_MAKES[mk]){
SX_VF.make=mk;
if(!SX_VD[mk])SX_VD[mk]={_loaded:true,_count:0};
(SX_VIRTUAL_MAKES[mk]||[]).forEach(function(src){
if(!SX_VD[src])return;
Object.keys(SX_VD[src]).forEach(function(mod){if(mod==='_loaded'||mod==='_count'||!Array.isArray(SX_VD[src][mod]))return;SX_VD[mk][src+' \u2014 '+mod]=SX_VD[src][mod];});
});
sxRenderModels();sxPanel('pm');return;
}
if(SX_MERGE_INTO[mk]){sxVfPickMake(SX_MERGE_INTO[mk],false);return;}
SX_VF.make=mk;
var mergedSrc=Object.keys(SX_MERGE_INTO).filter(function(s){return SX_MERGE_INTO[s]===mk;});
mergedSrc.forEach(function(src){
if(!SX_VD[src])return;
Object.keys(SX_VD[src]).forEach(function(mod){if(mod==='_loaded'||mod==='_count'||!Array.isArray(SX_VD[src][mod]))return;if(!SX_VD[mk][mod])SX_VD[mk][mod]=[];SX_VD[src][mod].forEach(function(p){if(!SX_VD[mk][mod].some(function(x){return x.s===p.s;}))SX_VD[mk][mod].push(p);});});
});
var pmTitle=document.getElementById('sx-pm-title');if(pmTitle)pmTitle.textContent=mk+' - Select Model';
var bcMakes=document.getElementById('sx-bc-makes');if(bcMakes)bcMakes.textContent='All Makes';
var mf=document.getElementById('sx-model-filter');if(mf)mf.value='';
if(SX_VD[mk]&&SX_VD[mk]._loaded){sxRenderModels();sxPanel('pm');}
else{var ml=document.getElementById('sx-model-list');if(ml)ml.innerHTML='<div style="padding:20px;color:var(--muted);text-align:center">Loading\u2026</div>';sxPanel('pm');sxLoadMake(mk,function(){sxRenderModels();});}
};
function sxRenderModels(filter){
var ft=(filter||'').toLowerCase();
var list=document.getElementById('sx-model-list');
if(!list||!SX_VF.make)return;
list.innerHTML='';
if(!ft&&window.sxWarmMake)window.sxWarmMake(SX_VD[SX_VF.make]);
var allMods=Object.keys(SX_VD[SX_VF.make]).filter(function(m){return m!=='_misc'&&m!=='_loaded'&&m!=='_count';});
var mods=ft?allMods.filter(function(m){return m.toLowerCase().indexOf(ft)>=0;}).sort():allMods.sort();
var groups=sxGetGroups(SX_VF.make);
var modelToGroup={};
Object.keys(groups).forEach(function(base){groups[base].forEach(function(m){modelToGroup[m]=base;});});
Object.keys(groups).forEach(function(g){
var isSeriesGroup=g.endsWith(' Series');
var prefix=isSeriesGroup?g.slice(0,-7):g;
var pl=prefix.toLowerCase();
Object.keys(SX_VD[SX_VF.make]||{}).forEach(function(key){
if(modelToGroup[key])return;
var kl=key.toLowerCase();
var directMatch=kl===pl||kl.startsWith(pl+' ')||kl.startsWith(pl+'-');
var nextChar=key.length>prefix.length?key[prefix.length]:'';
var shortMatch=isSeriesGroup&&prefix.length<=2&&kl.startsWith(pl)&&/[A-Z0-9]/i.test(nextChar);
if(directMatch||shortMatch)modelToGroup[key]=g;
});
});
(function(){
var leftover=Object.keys(SX_VD[SX_VF.make]||{}).filter(function(k){return k!=='_misc'&&k!=='_loaded'&&k!=='_count'&&!modelToGroup[k];});
if(leftover.length<2)return;
function firstToken(k){var m=k.match(/^([A-Za-z0-9]+)/);return m?m[1]:null;}
var byToken={};
leftover.forEach(function(k){
var tok=firstToken(k);if(!tok)return;
var tl=tok.toLowerCase();
var rest=k.slice(tok.length);
if(rest&&!/^[\s\-]/.test(rest))return;
if(!byToken[tl])byToken[tl]={label:tok,keys:[]};
byToken[tl].keys.push(k);
});
Object.keys(byToken).forEach(function(tl){
var entry=byToken[tl];
if(entry.keys.length<2)return;
var isNumeric=/^\d+$/.test(entry.label);
if(!isNumeric&&entry.label.length<2)return;
var groupName=isNumeric?(entry.label+' Series'):entry.label;
if(groups[groupName])return;
groups[groupName]=entry.keys.slice();
entry.keys.forEach(function(k){modelToGroup[k]=groupName;});
});
})();
var seen={},rows=[];
mods.forEach(function(m){
var groupBase=modelToGroup[m];
if(groupBase){if(seen[groupBase])return;seen[groupBase]=true;var total=groups[groupBase].reduce(function(sum,gm){return sum+(SX_VD[SX_VF.make][gm]?SX_VD[SX_VF.make][gm].length:0);},0);rows.push({label:groupBase,modKey:'__group__'+groupBase,count:total});}
else{
/* Struxa: inside a virtual make, an ungrouped key still carries its
   "<source> - " prefix, so the list read "Arb", "Back", "Crown - Canopy".
   Show the source name for both shapes. modKey stays the real key. */
var lbl=m;
if(SX_VIRTUAL_MAKES[SX_VF.make]&&m.indexOf(' \u2014 ')>0)lbl=m.split(' \u2014 ')[0];
rows.push({label:lbl,modKey:m,count:SX_VD[SX_VF.make][m].length});
}
});
rows.forEach(function(row){
if(!row.count)return;
var r=document.createElement('div');r.className='sx-model-row';
r.innerHTML='<span class="sx-model-name">'+row.label+'</span><span class="sx-model-badge">'+row.count+' product'+(row.count!==1?'s':'')+'</span>';
r.addEventListener('click',(function(mk){return function(){sxVfPickMod(mk);};})(row.modKey));
list.appendChild(r);
});
var misc=SX_VD[SX_VF.make]['_misc'];
if(misc&&misc.length&&!ft){
var lb=document.createElement('div');lb.className='sx-model-other-label';lb.textContent='Other / Unspecified';list.appendChild(lb);
var r2=document.createElement('div');r2.className='sx-model-row sx-misc';
r2.innerHTML='<span class="sx-model-name">Various / Unspecified</span><span class="sx-model-badge">'+misc.length+(misc.length===1?' product':' products')+'</span>';
r2.addEventListener('click',function(){sxVfPickMod('_misc');});
list.appendChild(r2);
}
if(!list.children.length)list.innerHTML='<div class="sx-empty">No models found</div>';
}
window.sxVfFilterModels=function(){
var mf=document.getElementById('sx-model-filter');sxRenderModels(mf?mf.value:'');
};
window.sxVfPickMod=function(m){
SX_VF.mod=m;
var label=m==='_misc'?'Various / Unspecified':m.startsWith('__group__')?m.slice(9):m;
var bcMake=document.getElementById('sx-bc-make');if(bcMake)bcMake.textContent=SX_VF.make;
var bcModel=document.getElementById('sx-bc-model');if(bcModel)bcModel.textContent=label;
var prTitle=document.getElementById('sx-pr-title');if(prTitle)prTitle.textContent=SX_VF.make+' - '+label;
var prods=sxGetProdsForMod(SX_VF.make,m);
sxLogVehicleSearch(SX_VF.make+" "+label,"makemodel",prods.length);
sxRenderResults(prods,null,null);
/* Struxa: sxRenderResults clears any stored match when there are no exact
   SKUs, which is right - a rego match must not leak onto a different car.
   But then nothing records WHICH car the customer is looking at, so anything
   added from here reached the cart with no vehicle on it at all. Record a
   tier-2 finder match: not a guarantee, just the vehicle they chose. Must run
   AFTER sxRenderResults, or it clears this straight back out. */
try{if(window.sxFit)window.sxFit.fromMatch({exact:false,source:'finder',vehicle:SX_VF.make+' '+label});}catch(e){}
sxBuildYearFilter(prods,null);
sxPanel('pr');
sxVfScrollToResults();
};
function sxGetProdsForMod(make,m){
if(m&&m.startsWith('__group__'))return sxGroupProducts(make,m.slice(9));
return(SX_VD[make]&&SX_VD[make][m])?SX_VD[make][m]:[];
}
function sxBuildYearFilter(allProds,rawYear){
var old=document.getElementById('sx-year-filter');if(old)old.remove();
if(!allProds||allProds.length===0)return;
var seen={},rawLabels=[];
allProds.forEach(function(p){var lbl=sxExtractYearLabel(p.t);if(lbl&&!seen[lbl]){seen[lbl]=true;rawLabels.push(lbl);}});
if(rawLabels.length<=1)return;
function parseLabel(l){var r=l.match(/^(\d{4})[^\d](\d{4})$/);if(r)return{s:parseInt(r[1]),e:parseInt(r[2])};var o=l.match(/^(\d{4}) on$/);if(o)return{s:parseInt(o[1]),e:9999};var s=l.match(/^(\d{4})$/);if(s)return{s:parseInt(s[1]),e:parseInt(s[1])};return null;}
function fmtLabel(s,e){return e===9999?s+' on':s===e?String(s):s+'\u2013'+e;}
rawLabels.sort(function(a,b){var pa=parseLabel(a),pb=parseLabel(b);return(pa?pa.s:0)-(pb?pb.s:0);});
var merged=[];
rawLabels.forEach(function(lbl){var p=parseLabel(lbl);if(!p){merged.push(lbl);return;}var last=merged.length?parseLabel(merged[merged.length-1]):null;if(last&&p.s<=last.e+3){merged[merged.length-1]=fmtLabel(Math.min(last.s,p.s),Math.max(last.e,p.e));}else{merged.push(lbl);}});
var labels=merged;
var bar=document.createElement('div');bar.id='sx-year-filter';bar.className='sx-year-filter';
var yl=document.createElement('span');yl.className='sx-year-label';yl.textContent='Filter year:';bar.appendChild(yl);
var allBtn=document.createElement('button');allBtn.className='sx-year-btn sx-active';allBtn.textContent='All';
allBtn.addEventListener('click',function(){bar.querySelectorAll('.sx-year-btn').forEach(function(b){b.classList.remove('sx-active');});allBtn.classList.add('sx-active');sxRenderResults(allProds,null,null);});
bar.appendChild(allBtn);
var autoLabel=null;if(rawYear)labels.forEach(function(label){if(sxLabelCoversYear(label,rawYear))autoLabel=label;});
if(!autoLabel)allBtn.classList.add('sx-active');
labels.forEach(function(label){
var btn=document.createElement('button');btn.className='sx-year-btn';if(label===autoLabel)btn.classList.add('sx-active');
btn.textContent=label;
btn.addEventListener('click',function(){bar.querySelectorAll('.sx-year-btn').forEach(function(b){b.classList.remove('sx-active');});btn.classList.add('sx-active');allBtn.classList.remove('sx-active');var split=sxFilterByLabelWithRanges(allProds,label);sxRenderResults(split.exact.concat(split.inRange),null,null);});
bar.appendChild(btn);
});
var rc=document.getElementById('sx-results-count');if(rc&&rc.parentNode)rc.parentNode.insertBefore(bar,rc);
if(autoLabel)setTimeout(function(){var split=sxFilterByLabelWithRanges(allProds,autoLabel);sxRenderResults(split.exact.concat(split.inRange),null,null);},0);
}
/* Two cards the customer cannot tell apart. There are two shapes of this and
   they need different sentences.

   SAME TITLE, TWICE. Counted on the live catalogue 29/10/2026: 49 titles are
   shared by two published products, 98 products in all. In 44 of those the
   only difference is the OE number list, so either one fits. In 5 an END
   FITTING differs with nothing in the title to say so - GS0071/GS0072,
   GS1219/GS1220, GS1297/GS1298, GS1915/GS1916, GS1910/GS1911. Browsing
   BMW > 3 Series puts four such pairs in one list of 30.

   SAME STRUT, DIFFERENT PRESSURE. GPJ211 ran the same rego four times over
   17 minutes and then guessed, which is why order #1007 carries
   "_fit_note: Partial match - force rating not confirmed". sxDedupeSamePart
   deliberately keeps force variants apart - merging an A3's 410N and 460N
   would be the exact failure Fit Assurance exists to prevent - so the answer
   is to label the choice, not remove it.

   Both end at the scanner, because the label carries the force AND the
   fitting, and it is already in the customer's hand. The copy does not claim
   the fittings differ (untrue for 44 of 49) or that either will do (untrue
   for the 5 that matter).

   Called from BOTH result paths, the rego lookup and the make/model browse.
   The title separator is whatever the data holds, so match an en/em dash or
   a hyphen rather than assuming. */
function sxLookalikeNote(list,prods){
try{
if(!list||!prods||!prods.length)return;
if(list.querySelector('.sx-lookalike-note'))return;
var seenForce={},seenTitle={},force=false,same=false;
prods.forEach(function(p){
var t=String((p&&p.t)||'').trim();
if(!t)return;
if(seenTitle[t])same=true;
seenTitle[t]=1;
var m=t.match(/^(.*?)[\s\u2013\u2014\-]+(\d{2,4})N$/);
if(!m)return;
var base=m[1].trim(),f=m[2];
if(seenForce[base]&&seenForce[base]!==f)force=true;
seenForce[base]=f;
});
if(!force&&!same)return;
var msg='';
if(same)msg+='Two of these look identical. They are different part numbers, '
+'and on some vehicles the end fittings differ. ';
/* Reads badly as "Two of these... Two of these..." when both apply. */
if(force)msg+=(same?'Two others are':'Two of these are')
+' the same strut at different pressures. '
+'The N number is printed on the label of your old strut. ';
msg+=(force?'':'The details are printed on the label of your old strut. ');
var fn=document.createElement('div');
fn.className='sx-possible-banner sx-lookalike-note sx-force-note';
fn.innerHTML='<span>'+msg
+'<a href="/pages/label-scanner">Scan or photograph it</a> and we will match it exactly.</span>';
list.appendChild(fn);
}catch(e){}
}
function sxRenderResults(prods,exactSkus,carYear){try{if(window.sxFit&&!exactSkus)window.sxFit.clear();}catch(e){}
var list=document.getElementById('sx-result-list');
var rc=document.getElementById('sx-results-count');
if(!list)return;
list.innerHTML='';
if(rc)rc.textContent=prods.length+' product'+(prods.length!==1?'s':'')+' found';
if(!prods.length){
list.innerHTML='<div class="sx-empty sx-not-found">'+sxDeadEndText('We do not have a strut listed for this vehicle yet.')+sxDeadEndActions(SX_SCROLL_TO_CONTACT)+'</div>';
return;
}
var sorted=prods.slice().sort(function(a,b){return sxProductStartYear(b.t)-sxProductStartYear(a.t);});
sorted.forEach(function(p){list.appendChild(sxBuildCard(p,false));});
sxLookalikeNote(list,sorted);
sxAddContactFooter(list);
}
/* EVERY DEAD END OFFERS THE SCANNER FIRST, THEN CONTACT US. Dave, 10/09/2026.

   Before this, all four dead ends on this page ended at "Contact Us" and
   nothing else. That is the weaker of the two answers: the label on the strut
   they are replacing carries the exact part number, so scanning it settles
   length, force AND end fittings in about thirty seconds, where an email is a
   conversation and a day. It is also already what Fit Assurance tells a tier-2
   customer to do, so the two surfaces now say the same thing.

   Contact Us stays, because a label can be worn off, painted over, or the old
   strut is already in a skip. It is the fallback, not the first offer.

   ONE PAIR OF FUNCTIONS so the four dead ends cannot drift apart in wording -
   same reason the cart-line name was consolidated. */
function sxDeadEndActions(contactOnClick){
  return '<div class="sx-nf-actions">'
    + '<a class="sx-contact-btn" href="/pages/label-scanner">Scan my strut label</a>'
    + '<button class="sx-scan-alt" onclick="' + contactOnClick + '">Contact us</button>'
    + '</div>';
}

/* `lead` is what is specific to this dead end. Everything after it is
   identical everywhere, on purpose. */
function sxDeadEndText(lead){
  return '<span>' + lead + ' Try scanning the label on your original gas strut and we will '
    + 'match it exactly. If that does not work, contact us and we will find the right '
    + 'gas strut for you.</span>';
}

var SX_SCROLL_TO_CONTACT = "document.getElementById('sx-contact').scrollIntoView({behavior:'smooth'})";

function sxAddContactFooter(list){
var old=list.querySelector('.sx-contact-footer');if(old)old.remove();
var footer=document.createElement('div');footer.className='sx-contact-footer';
footer.innerHTML='<p>None of these the right one? Try scanning the label on your original gas strut and we will match it exactly. If that does not work, contact us and we will find the right gas strut for you.</p>'
+sxDeadEndActions('sxVfFillContact()');
list.appendChild(footer);
}
function sxApplyOeScoring(products,engine,chassis,year,make,model,callback,chassisVars,cc){
if(!engine&&!chassis&&!cc){callback({exact:[],possible:products});return;}
var oeDone=false;
var oeTimer=setTimeout(function(){if(!oeDone){oeDone=true;callback({exact:[],possible:products});}},8000);
fetch(SX_OE_API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({engine:engine,chassis:chassis,chassis_variants:chassisVars||[],cc:cc,make:make,model:model,year:year})})
.then(function(r){return r.json();})
.then(function(data){
clearTimeout(oeTimer);
var exactSkus={};
(data.exact_skus||[]).forEach(function(s){exactSkus[s]=true;});
var exact=products.filter(function(p){return p.s&&exactSkus[p.s];});
var possible=products.filter(function(p){return!p.s||!exactSkus[p.s];});
if(!oeDone){oeDone=true;callback({exact:exact,possible:possible});}
})
.catch(function(){if(!oeDone){clearTimeout(oeTimer);oeDone=true;callback({exact:[],possible:products});}});
}
/* Struxa: how far down the sticky header pushes the top of the viewport, so a
   scroll does not park the results heading underneath it. Measured rather than
   hardcoded - the header height changes between mobile and desktop. */
function sxVfHeaderOffset(){
var h=0;
var els=document.querySelectorAll('header,.header-wrapper,sticky-header,#shopify-section-header');
for(var i=0;i<els.length;i++){
var s=window.getComputedStyle(els[i]);
if(s.position!=='fixed'&&s.position!=='sticky')continue;
var r=els[i].getBoundingClientRect();
if(r.top<=1&&r.height>h)h=r.height;
}
return h;
}

/* Struxa: a successful rego lookup rendered the results below the fold, so the
   customer was left looking at the search box and the 1 / 2 / 3 strip with no
   sign that anything had happened. Bring the results heading up to just under
   the sticky header - but only when it is not already fully on screen, and
   never on a failed lookup, where the message sits by the input on purpose. */
function sxVfScrollToResults(){
var target=document.getElementById('sx-pr-title')||document.getElementById('sx-pr');
if(!target)return;
var off=sxVfHeaderOffset()+16;
var r=target.getBoundingClientRect();
var vh=window.innerHeight||document.documentElement.clientHeight;
if(r.top>=off&&r.bottom<=vh)return;
var reduce=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
var top=r.top+(window.pageYOffset||document.documentElement.scrollTop||0)-off;
if(top<0)top=0;
try{window.scrollTo({top:top,behavior:reduce?'auto':'smooth'});}
catch(e){window.scrollTo(0,top);}
}

/* One place that owns "a rego lookup is running".
   Before this, SX_VF.regoInProgress was set but only ever READ to decide
   whether to hide a status line - it never stopped a second lookup, and the
   button was never disabled. Three clicks measured on the live page fired
   FIVE CarJam calls (three clicks plus two automatic retries), each one
   billed, each one writing another row to the search log. That is what the
   four GPJ211 rows on 27/10 were.
   The button has no id - it is wired by an inline onclick - so it is found
   by its class inside the rego panel. */
function sxVfRegoBtn(){
try{
var b=document.querySelector('#sx-rego-panel .sx-search-btn');
if(b)return b;
var all=[].slice.call(document.querySelectorAll('button.sx-search-btn'));
for(var i=0;i<all.length;i++){if(/sxVfSearchRego/.test(all[i].getAttribute('onclick')||''))return all[i];}
}catch(e){}
return null;
}
function sxVfRegoBusy(on){
SX_VF.regoInProgress=!!on;
var b=sxVfRegoBtn();
if(b){b.disabled=!!on;b.textContent=on?'Looking up\u2026':'Look Up Rego';}
}
/* Log the OUTCOME, not the intent. This used to run before the lookup with a
   hardcoded null, so every rego row in the log read "-" and you could not
   tell a hit from a miss - only that somebody pressed the button. Guarded so
   one lookup logs once however it ends. */
function sxVfRegoLog(plate,count){
if(!plate||SX_VF._regoLogged===plate)return;
SX_VF._regoLogged=plate;
try{sxLogVehicleSearch(plate,'rego',(typeof count==='number'?count:null));}catch(e){}
}
window.sxVfSearchRego=function(){
var ri=document.getElementById('sx-rego-inp');if(!ri)return;
var val=ri.value.trim().toUpperCase();
/* People write a plate the way it is painted on the plate - "ABC 123" or
   "ABC-123". Collapse the separator, but ONLY when what is left is still
   plate-shaped, so "TOYOTA COROLLA" (13 chars once compacted) is untouched
   and still reaches the make/model tab instead of burning a paid lookup. */
if(/^[A-Z0-9]+[\s-]+[A-Z0-9]+$/.test(val)){var sxvfCompact=val.replace(/[\s-]+/g,'');if(sxvfCompact.length<=6)val=sxvfCompact;}if(!val)return;
/* Struxa: people type "toyota hilux" into the rego box. Sending that to
   CarJam just burns a lookup and answers "no vehicle found", so hand it to
   the make/model tab instead - one box, right destination. */
if(!sxVfIsRego(val)){var rawVal=ri.value.trim();sxVfOpenQuery(rawVal);return;}
var mi=document.getElementById('sx-model-inp');if(mi)mi.value=val;
SX_VF.plate=val;SX_VF._regoLogged=null;sxVfRegoBusy(true);try{sessionStorage.setItem('stx_last_rego',val);}catch(e){}
sxStatusShow('Looking up '+val+'\u2026');
var hintEl=document.getElementById('sx-rego-hint');if(hintEl)hintEl.textContent='';
var vi=document.getElementById('sx-vehicle-badge');if(vi)vi.remove();
var nf=document.getElementById('sx-not-found');if(nf)nf.remove();
function doLookup(attempt){
var controller=typeof AbortController!=='undefined'?new AbortController():null;
var timer=controller?setTimeout(function(){controller.abort();},8000):null;
fetch(SX_CARJAM_PROXY+'?plate='+encodeURIComponent(val),controller?{signal:controller.signal}:{})
.then(function(r){if(timer)clearTimeout(timer);return r.json();})
.then(function(data){
var v2=(data&&data.vehicle)?data.vehicle:data;
var rawMake=(v2&&v2.make)?v2.make:'';
/* NO CLIENT RETRY ON AN EMPTY RESULT, deliberately. This used to retry twice,
   two seconds apart, because the old proxy forwarded CarJam's 200-null - its
   "still fetching" placeholder - straight through, so the browser had to poll.
   struxa-api/api/rego.js now handles that server-side and waits the exact time
   CarJam's own Refresh header asks for, which the browser cannot see.
   Retrying here does not help: an empty body now means a real 404, not "wait a
   moment". It just adds two seconds before we admit it, and since a
   still-fetching miss is no longer cached, each retry is another paid CarJam
   lookup. Fall through to the not-found panel instead. The .catch() below
   still retries, which is a different case - that one never got an answer. */
var rawModel=(v2&&v2.model)?v2.model:'';
if(rawMake&&rawModel){var makePfx=rawMake.replace(/[^a-zA-Z0-9]/g,'').toUpperCase();var modelUp=rawModel.replace(/[^a-zA-Z0-9]/g,'').toUpperCase();if(modelUp.startsWith(makePfx))rawModel=rawModel.slice(rawMake.replace(/[^a-zA-Z0-9 ]/g,'').length).trim();}
rawModel=rawModel.replace(/^([A-Z]{2,})(\d)/,function(m,a,b){return a+'-'+b;});
rawModel=rawModel.toLowerCase().replace(/\b([a-z])/g,function(c){return c.toUpperCase();});
var rawYear=(v2&&(v2.year_of_manufacture||v2.year))?String(v2.year_of_manufacture||v2.year):'';
var rawBody=(v2&&(v2.body_style||v2.body||v2.vehicle_body))?(v2.body_style||v2.body||v2.vehicle_body):'';
var rawEngineRaw=String(v2.engine_type||v2.engine_code||v2.engine_no||v2.engine||'');
var rawEngine='';
if(rawEngineRaw){var engSeg=rawEngineRaw.toUpperCase().split(/[\s\-]/)[0];var engMatch=engSeg.match(/^([A-Z0-9]{2,8})/);rawEngine=engMatch?engMatch[1]:engSeg.slice(0,6);}
var rawCCRaw=String(v2.cc_rating||v2.cc||v2.engine_cc||'');
var rawCC='';
if(rawCCRaw){var litreMatch=rawCCRaw.match(/\((\d+\.?\d*)\s*[lL]\)/);if(litreMatch){rawCC=litreMatch[1];}else{var ccInt=parseInt(rawCCRaw.replace(/,/g,'').match(/(\d+)/)?.[1]||'0');if(ccInt>100)rawCC=(ccInt/1000).toFixed(1);}}
if(rawCC&&!rawEngine)rawEngine=rawCC;
var rawChassisRaw=String(v2.chassis_number||v2.chassis||v2.chassis_no||v2.vehicle_chassis||v2.vin_chassis||v2.chassisNumber||v2.chassis_code||v2.body_number||'');
if(!rawChassisRaw&&v2.vin)rawChassisRaw=String(v2.vin).slice(0,11);
var rawChassis='';
if(rawChassisRaw){var chassisStr=rawChassisRaw.toUpperCase().replace(/\s/g,'');var chassisParts=chassisStr.split('-');if(chassisParts.length>1){rawChassis=chassisParts[0].slice(0,8);}else{var chassisMatch=chassisStr.match(/^([A-Z]{1,4}\d{1,4}[A-Z]{0,2})/);rawChassis=chassisMatch?chassisMatch[1]:chassisStr.slice(0,6);}}
var chassisVariants=[];
if(rawChassis){chassisVariants.push(rawChassis);if(rawChassis.length>2)chassisVariants.push(rawChassis.slice(1));var noLead=rawChassis.replace(/^[A-Z]+/,'');if(noLead.length>=2&&chassisVariants.indexOf(noLead)<0)chassisVariants.push(noLead);var noTrail=rawChassis.replace(/[A-Z]+$/,'');if(noTrail.length>=2&&noTrail!==rawChassis&&chassisVariants.indexOf(noTrail)<0)chassisVariants.push(noTrail);}
if(rawMake){
var GH_MAKE_ALIASES={'mercedes-benz':'Mercedes-Benz','mercedes benz':'Mercedes-Benz','vw':'Volkswagen','volkswagen ag':'Volkswagen','land-rover':'Land Rover','landrover':'Land Rover','range-rover':'Range Rover','rangerover':'Range Rover','alfa-romeo':'Alfa Romeo','alfaromeo':'Alfa Romeo','bmw ag':'BMW','mitsubishi motors':'Mitsubishi','general motors':'Holden','gm':'Holden','honda motor':'Honda','nissan motor':'Nissan','toyota motor':'Toyota','ford motor':'Ford','mazda motor':'Mazda','hyundai motor':'Hyundai','kia motors':'Kia','vauxhall':'Holden','lexus':'Toyota','land rover':'Land Rover','range rover':'Range Rover','mercedes benz':'Mercedes-Benz','great wall':'Chinese','foton':'Chinese','holden ltd':'Holden','general motors holden':'Holden','rover cars':'Rover','rover group':'Rover','mg motor':'Rover'};
var rawMakeNorm=rawMake.toLowerCase().replace(/[-_]/g,' ').trim();
var mk=SX_MAKES.find(function(x){return x.toLowerCase()===(GH_MAKE_ALIASES[rawMakeNorm]||'').toLowerCase();});
if(!mk)mk=SX_MAKES.find(function(x){return x.toLowerCase()===rawMakeNorm;});
if(!mk)mk=SX_MAKES.find(function(x){return x.toLowerCase().indexOf(rawMakeNorm)>=0;});
if(!mk)mk=SX_MAKES.find(function(x){return rawMakeNorm.indexOf(x.toLowerCase())>=0;});
if(!mk){var firstWord=rawMakeNorm.split(/[\s\-]+/)[0];mk=SX_MAKES.find(function(x){return x.toLowerCase()===firstWord;});}
if(mk){
var infoText=rawMake+(rawModel?' '+rawModel:'')+(rawYear?' \u00b7 '+rawYear:'')+(rawBody?' \u00b7 '+rawBody:'');
var badge=document.createElement('div');badge.id='sx-vehicle-badge';badge.className='sx-vehicle-badge';
badge.textContent='\uD83D\uDE97 '+infoText;
var srRego=document.getElementById('sx-rego-panel');if(srRego)srRego.appendChild(badge);
sxStatusHide();sxVfRegoBusy(false);
var doFilter=function(){
if(!rawModel){
var _all=[];Object.keys(SX_VD[mk]).forEach(function(mod){if(mod==='_loaded'||mod==='_count')return;if(Array.isArray(SX_VD[mk][mod]))_all=_all.concat(SX_VD[mk][mod]);});
SX_VF.make=mk;SX_VF.mod='__all__';
var bcMake=document.getElementById('sx-bc-make');if(bcMake)bcMake.textContent=mk;
var bcModel=document.getElementById('sx-bc-model');if(bcModel)bcModel.textContent='All Models';
var prTitle=document.getElementById('sx-pr-title');if(prTitle)prTitle.textContent=mk+' - All Models';
var yearSorted=_all.slice().sort(function(a,b){return sxRegoSortScore(a.t,rawYear)-sxRegoSortScore(b.t,rawYear);});
sxApplyOeScoring(yearSorted,rawEngine,rawChassis,rawYear,mk,'All Models',function(split){sxRenderRegoResults(split,mk,'All Models',rawYear,val);},chassisVariants,rawCC);
sxPanel('pr');sxVfScrollToResults();return;
}
/* CarJam gives the name the car was imported under; this catalogue is a
   European one. Keyed on the normalised name so 'Step Wagon', 'STEPWGN'
   and 'Stepwgn' all land. Atenza and Demio are deliberately absent: this
   catalogue lists them as their own models, unlike gasstrutshb's. */
var SXMA={
march:'Micra',
axela:'3',mazda3:'3',mazda2:'2',mazda6:'6',roadster:'Mx5',lantis:'Astina',millenia:'Eunos',
fit:'Jazz',vezel:'HR-V',grace:'City',stepwgn:'Stepwagon',stepwagon:'Stepwagon',
belta:'Yaris',vellfire:'Alphard',voxy:'Noah',esquire:'Noah',platz:'Echo',
succeed:'Probox',cynos:'Paseo',cresta:'Chaser',
ad:'Wingroad',sylphy:'Pulsar',bluebirdsylphy:'Pulsar',liberty:'Prairie',
lancaster:'Outback',verada:'Magna',every:'Carry',aerio:'Liana',baleno:'Cultus',
boon:'Sirion',cuore:'Mira'
};
if(SXMA[sxNorm(rawModel)])rawModel=SXMA[sxNorm(rawModel)];
var matches=sxFuzzyModels(mk,rawModel);if(!matches.length&&/mercedes/i.test(mk)){var mc=rawModel.match(/^([ABCES])[0-9]{2,3}$/i);if(mc){var cp=mc[1].toLowerCase()+'class';rawModel=mc[1].toUpperCase()+'-Class';matches=sxFuzzyModels(mk,rawModel).filter(function(q){return sxNorm(q).indexOf(cp)===0;});}}
var groups=sxGetGroups(mk);
var groupMatches=(function(){
var nr=sxNorm(rawModel);var qw=rawModel.toLowerCase().replace(/[^a-z0-9]/g,' ').split(/\s+/).filter(function(w){return w.length>1;});
var t1=Object.keys(groups).filter(function(base){var bw=base.toLowerCase().replace(/[^a-z0-9]/g,' ').split(/\s+/).filter(function(w){return w.length>1;});return qw.every(function(q){return bw.some(function(k){return k.indexOf(q)===0||q.indexOf(k)===0;});});});
if(t1.length)return t1;
return Object.keys(groups).filter(function(base){var nb=sxNorm(base);return nb.indexOf(nr)===0||nr.indexOf(nb)===0;});
})();
if(typeof cp!=='undefined'&&cp)groupMatches=groupMatches.filter(function(q){return sxNorm(q).indexOf(cp)===0;});
/* A numbered model must keep its number. sigWords drops one-character
   tokens, so 'CX-5' arrives here as ['cx'] and happily matches 'CX-3' -
   and Mazda has a CX-3 and no CX-5, so the match was not just loose, it
   was the wrong car at the right price with an Add to Cart. Only applies
   when BOTH names carry a number, so 'Delica D5' still reaches 'Delica'. */
groupMatches=(function(gm){
var qn=sxModelNum(rawModel);
if(!qn)return gm;
var kept=gm.filter(function(b){var bn=sxModelNum(b);return !bn||bn===qn;});
return kept.length?kept:[];
})(groupMatches);
(function(){var eq=sxNorm(rawModel);var ex=groupMatches.filter(function(x){return sxNorm(x)===eq;});if(ex.length)groupMatches=ex;})();var allProducts=[],usedGroupKeys={};
groupMatches.forEach(function(base){allProducts=allProducts.concat(sxGroupProducts(mk,base));usedGroupKeys[base]=true;});
matches.forEach(function(m){var inGroup=Object.keys(groups).some(function(base){return usedGroupKeys[base]&&groups[base].indexOf(m)>=0;});if(!inGroup&&SX_VD[mk]&&SX_VD[mk][m])allProducts=allProducts.concat(SX_VD[mk][m]);});
var displayLabel=groupMatches.length>0?groupMatches[0]:(matches.length>0?matches[0]:rawModel);
SX_VF.make=mk;SX_VF.mod='__rego__';SX_VF.regoFilter=rawModel;
var bcMake2=document.getElementById('sx-bc-make');if(bcMake2)bcMake2.textContent=mk;
var bcModel2=document.getElementById('sx-bc-model');if(bcModel2)bcModel2.textContent=displayLabel;
var prTitle2=document.getElementById('sx-pr-title');if(prTitle2)prTitle2.textContent=mk+' - '+displayLabel;
if(!allProducts.length){
var list=document.getElementById('sx-result-list');if(list)list.innerHTML='';
var rc=document.getElementById('sx-results-count');if(rc)rc.textContent='0 products found';
sxRenderResults([],null,null);sxPanel('pr');sxVfScrollToResults();return;
}
var yearSorted2=allProducts.slice().sort(function(a,b){return sxRegoSortScore(a.t,rawYear)-sxRegoSortScore(b.t,rawYear);});
sxApplyOeScoring(yearSorted2,rawEngine,rawChassis,rawYear,mk,displayLabel,function(split){sxRenderRegoResults(split,mk,displayLabel,rawYear,val);},chassisVariants,rawCC);
sxPanel('pr');
sxVfScrollToResults();
};
/* Do NOT log the count here. doFilter() only STARTS the lookup -
   SX_REGO_PRODS is filled in sxRenderRegoResults, which is the OE
   scoring callback, so reading it now records the value from before
   the answer arrived. That is what made every row read 0. */
if(SX_VD[mk]&&SX_VD[mk]._loaded){doFilter();}
else{sxLoadMake(mk,function(){doFilter();});}
return;
}
sxVfRegoBusy(false);sxStatusHide();sxVfRegoLog(val,0);
if(hintEl)hintEl.textContent=rawMake+' not in our catalogue';
var nf2=document.createElement('div');nf2.id='sx-not-found';nf2.className='sx-not-found';
nf2.innerHTML=sxDeadEndText(rawMake+' is not in our vehicle catalogue yet.')+sxDeadEndActions(SX_SCROLL_TO_CONTACT);
var rp=document.getElementById('sx-rego-panel');if(rp)rp.appendChild(nf2);
sxRenderMakes();sxPanel('pp');return;
}
sxVfRegoBusy(false);sxStatusHide();sxVfRegoLog(val,0);
if(hintEl)hintEl.textContent='Rego not found - try the Make / Model tab';
var nf3=document.createElement('div');nf3.id='sx-not-found';nf3.className='sx-not-found';
nf3.innerHTML=sxDeadEndText('We could not find that plate.')+sxDeadEndActions(SX_SCROLL_TO_CONTACT);
var rp2=document.getElementById('sx-rego-panel');if(rp2)rp2.appendChild(nf3);
sxRenderMakes();sxPanel('pp');
})
.catch(function(){
if(timer)clearTimeout(timer);
if(attempt<2){setTimeout(function(){doLookup(attempt+1);},2000);}
else{sxVfRegoBusy(false);sxStatusHide();sxVfRegoLog(val,null);if(hintEl)hintEl.textContent='Rego lookup failed - try the Make / Model tab';sxRenderMakes();sxPanel('pp');}
});
}
doLookup(1);
};
function sxRenderRegoResults(split,mk,displayLabel,rawYear,plate){
SX_REGO_PRODS=(split.exact||[]).concat(split.possible||[]);
/* The only line that knows how many the lookup actually found. */
sxVfRegoLog(plate,SX_REGO_PRODS.length);try{if(window.sxFit){var _fx=(split.exact||[]);window.sxFit.fromMatch({exact:_fx.length>0,source:'rego',vehicle:mk+' '+displayLabel+(rawYear?' ('+rawYear+')':''),plate:plate||'',skus:_fx.map(function(_p){return _p.s;}).filter(Boolean)});}}catch(e){}
var list=document.getElementById('sx-result-list');if(!list)return;
list.innerHTML='';
var rc=document.getElementById('sx-results-count');
var exactProds=sxDedupeSamePart(split.exact||[],rawYear),possibleProds=sxDedupeSamePart(split.possible||[],rawYear);
var total=exactProds.length+possibleProds.length;
if(rc)rc.textContent=total+' product'+(total!==1?'s':'')+' found';
sxLookalikeNote(list,exactProds.concat(possibleProds));
if(exactProds.length){
var eb=document.createElement('div');eb.className='sx-exact-banner';
eb.innerHTML='<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="9" fill="#16a34a"/><path d="M5 9l3 3 5-5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg><span>\u2713 Confirmed match for your '+mk+' '+displayLabel+(rawYear?' ('+rawYear+')':'')+'</span>';
list.appendChild(eb);
exactProds.forEach(function(p){list.appendChild(sxBuildCard(p,true));});
}
if(possibleProds.length){
if(exactProds.length){
var pb=document.createElement('div');pb.className='sx-possible-banner';
pb.innerHTML='<span>Other struts for this vehicle - may also fit</span>';
list.appendChild(pb);
} else if(rawYear){
var inRange=possibleProds.filter(function(p){var r=sxGetYearRange(p.t);var y=parseInt(rawYear)||0;return y>=r.s&&y<=r.e;});
if(inRange.length){
var yb=document.createElement('div');yb.className='sx-possible-banner sx-year-banner';
yb.innerHTML='<strong>Possible match</strong> - year range includes your '+rawYear+' '+mk+'. Measure your original strut to confirm size before ordering.';
list.appendChild(yb);
inRange.forEach(function(p){list.appendChild(sxBuildCard(p,false));});
sxAddContactFooter(list);return;
}
/* Struxa: we know the car's year and NOTHING in this list covers it. This
   used to fall straight through and render every product with no banner at
   all - a 2013 CR-V was shown a strut titled "(1996)" with nothing to say
   the years do not line up. Products titled with a single year are the worst
   of it, because sxGetYearRange gives them {s:1996,e:1996} and they can
   never match anything else. Say so plainly instead of implying a fit. */
var yw=document.createElement('div');yw.className='sx-possible-banner sx-year-banner sx-year-warn';
yw.innerHTML='<strong>None of these list your '+rawYear+'</strong> - they are the struts we hold for a '+mk+(displayLabel&&displayLabel!=='All Models'?' '+displayLabel:'')+', but their listed years do not include '+rawYear+'. Measure your original strut fully extended, centre of ball socket to centre of ball socket, before ordering - or send us a photo of its label and we will confirm it.';
list.appendChild(yw);
}
possibleProds.forEach(function(p){list.appendChild(sxBuildCard(p,false));});
}
sxAddContactFooter(list);
}

/* ------------------------------------------------------------------
   Struxa: trade and bulk pricing on finder cards.

   The finder used to print p.p flat, so a trade customer saw retail here
   and their real price only at checkout - and the All Gas Struts page
   showed the discount, which made the two pages disagree. This mirrors
   what gas-struts-catalogue.js does, off the same two globals:

     window.SX_TRADE - {pct, tier, elite}, emitted by layout/theme.liquid
                       from the customer's tier tag.
     window.SX_BULK  - {qty, percent}, the bulk discount theme settings.

   Shopify applies ONE automatic discount - the best one - so trade and
   bulk do not stack, and neither does this. A Trade customer buying 12
   struts gets their 10%, not 20%. Whatever this shows has to be what
   checkout charges, or the card is lying.

   TO REVERT: put the old one-line priceHtml back and delete this block.
   ------------------------------------------------------------------ */
function sxTradePct(){ return (window.SX_TRADE && +window.SX_TRADE.pct) || 0; }
function sxBulkQty(){ return (window.SX_BULK && +window.SX_BULK.qty) || 10; }
function sxBulkPct(){ return (window.SX_BULK && +window.SX_BULK.percent) || 10; }

function sxBestDiscount(qty){
  var trade = sxTradePct();
  var isBulk = qty >= sxBulkQty();
  var bulk  = isBulk ? sxBulkPct() : 0;
  /* Struxa: Elite is the one tier where bulk stacks - there is a separate
     automatic discount in Shopify ("Elite Bulk Discount - 10+ Gas Struts",
     25%, min qty 10, Tier: Elite segment) that beats the flat Elite 22%.
     Anything shown here has to be what checkout actually charges. */
  if (isBulk && window.SX_TRADE && window.SX_TRADE.elite) {
    return { pct: trade + 5, why: 'Elite bulk price' };
  }
  if (trade >= bulk) return { pct: trade, why: trade ? 'Trade price' : '' };
  return { pct: bulk, why: sxBulkQty() + '+ bulk price' };
}

function sxMoney(n){ return '$' + n.toFixed(2); }

function sxPriceInner(base, qty){
  var d = sxBestDiscount(qty || 1);
  if (!d.pct) return sxMoney(base);
  var now = base * (1 - d.pct / 100);
  var label = (d.pct % 1 === 0 ? d.pct.toFixed(0) : d.pct.toFixed(1)) + '% off';
  return '<span class="sx-price-was">' + sxMoney(base) + '</span>' +
         '<span class="sx-price-now">' + sxMoney(now) + '</span>' +
         '<span class="sx-price-tag">' + label + (d.why ? ' · ' + d.why : '') + '</span>';
}

function sxRepriceCard(card, qtyEl){
  if (!card) return;
  var el = card.querySelector('.sx-prod-price');
  if (!el) return;
  var base = parseFloat(el.getAttribute('data-sx-base'));
  if (!base) return;
  var qty = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
  el.innerHTML = sxPriceInner(base, qty);
}

/* The finder's CSS lives in the page template, not in a stylesheet, so
   these few rules ship with the behaviour rather than needing a second
   edit in a 114 KB JSON file every time they change. sxBuildCard below is
   the only thing that writes .sx-view-link, so its styling lives here too
   and reaches every surface that renders these cards - the NZ vehicle store
   and the Trade Portal both build their cards from this file. */
(function sxCardCss(){
  if (document.getElementById('sx-card-css')) return;
  var st = document.createElement('style');
  st.id = 'sx-card-css';
  st.textContent =
    '.sx-vf .sx-prod-price{display:flex;flex-direction:column;align-items:flex-end;gap:1px;}' +
    /* Height reserved so the card does not jump when the live price lands. */
    '.sx-vf .sx-prod-price.sx-price-pending{min-height:34px;}' +
    '.sx-vf .sx-price-was{font-size:14px;font-weight:600;color:#1c1e22;text-decoration:line-through;line-height:1.1;}' +
    '.sx-vf .sx-price-now{font-size:24px;font-weight:800;color:#1c1e22;line-height:1;}' +
    '.sx-vf .sx-price-tag{font-size:11px;font-weight:700;letter-spacing:.02em;color:#ff7a00;text-transform:uppercase;line-height:1.2;}' +
    /* "View details" had no rule at all, so it rendered as a default browser
       link - blue, underlined - under a black uppercase button. Same mono
       small-caps label treatment as .sx-tag, in the card's own muted ink,
       with a hairline underline so it still reads as clickable. */
    '.sx-vf .sx-view-link{font-family:var(--mono),monospace;font-size:11px;font-weight:500;text-transform:uppercase;letter-spacing:.08em;color:var(--muted2,#55555a);text-decoration:none;padding:2px 0;border-bottom:1px solid var(--border,#ddddd8);cursor:pointer;transition:color .15s,border-color .15s;}' +
    '.sx-vf .sx-view-link:hover{color:var(--black,#17171a);border-bottom-color:var(--black,#17171a);}' +
    '.sx-vf .sx-view-link:focus-visible{outline:2px solid var(--orange,#ff7a00);outline-offset:3px;color:var(--black,#17171a);}';
  (document.head || document.documentElement).appendChild(st);
})();

/* Shopify could not find this SKU, so there is nothing to buy and nothing to
   link to. Unpublished is the common cause - a draft product is absent from
   /search/suggest.json - but a deleted or renamed SKU lands here too.
   Before this the card simply lost its pending state and sat there with a
   live Add to Cart, no price, and a View Details pointing at a 404. */
function sxMarkCardUnavailable(card){
try{
card.classList.add('sx-card-unavailable');
var pe=card.querySelector('.sx-prod-price');
if(pe){pe.classList.remove('sx-price-pending');pe.textContent='Not available online';}
var kill=card.querySelectorAll('.sx-atc-btn,.sx-qty-btn,.sx-qty-minus,.sx-qty-plus');
for(var i=0;i<kill.length;i++){
var b=kill[i];
b.disabled=true;
b.setAttribute('aria-disabled','true');
b.style.opacity='.45';
b.style.pointerEvents='none';
}
var atc=card.querySelector('.sx-atc-btn');
if(atc)atc.textContent='Ask us about this one';
/* The product page 404s, so do not send anyone to it. */
var ls=card.querySelectorAll('.sx-view-btn,.sx-view-link');
for(var j=0;j<ls.length;j++){ls[j].setAttribute('href','/pages/contact');ls[j].textContent='Ask us';}
}catch(e){}
}
window.sxBuildCard = sxBuildCard;function sxBuildCard(p,isExact){
sxWarmRefCode();
var isBracket=p.b===1,isStruxa=p.x===1;
var rawUrl=(p.u&&p.u.indexOf('hostingersite.com')<0)?p.u:SX_PROD_BASE;
var url=sxFixUrl(rawUrl);url=url+(url.indexOf('?')>-1?'&':'?')+'sxfrom=vs';
var img=(p.i&&p.i.indexOf('r2.dev')<0&&p.i.indexOf('hostingersite.com')<0)?p.i:SX_FALLBACK_IMG;var ihold=sxImgHold(img,p.s);
var yearTag=sxExtractYearTag(p.t);
var tags='';
if(yearTag)tags+='<span class="sx-tag sx-tag-year">'+yearTag+'</span>';
if(p.l)tags+='<span class="sx-tag sx-tag-brand">'+p.l+'</span>';
if(p.z)tags+='<span class="sx-tag sx-tag-size">'+p.z+'mm</span>';
if(p.d)tags+='<span class="sx-tag sx-tag-loc">'+p.d+'</span>';
if(p.s)tags+='<span class="sx-tag sx-tag-sku">'+p.s+'</span>';
var priceHtml='';
/* A CARD WITH A SKU PAINTS NO PRICE UNTIL SHOPIFY ANSWERS.
   The data file still says 68 where Shopify charges 75, so painting the
   file price first meant every card showed $68 and then corrected itself
   to $75 a moment later. Showing a lower number and then raising it is
   worse than showing none: it is what makes someone re-check the cart
   total and trust it less. sxResolveSku fills this in below, and it is
   already being called for every card that has a SKU, so nothing waits
   any longer than it did before.
   No SKU means no lookup is coming, so the file price is all there is
   and it is still used. */
if(p.p&&p.p!=='0.00'){
  var sxAwaitLive=!!p.s;
  priceHtml='<div class="sx-prod-price'+(sxAwaitLive?' sx-price-pending':'')+'" data-sx-base="'+parseFloat(p.p)+'">'
    +(sxAwaitLive?'':sxPriceInner(parseFloat(p.p),1))+'</div><div class="sx-prod-brand-label '
    +(isStruxa?'sx-struxa':'sx-stabilus')+'">'+(isStruxa?'STRUXA':'STABILUS')+'</div>';
}
var ctaHtml='';
if(isBracket){ctaHtml='<button class="sx-contact-btn" onclick="event.stopPropagation();sxVfFillContact(\''+p.t.replace(/'/g,"\\'")+'\');" style="width:100%;margin-bottom:6px;">Contact Us</button><a class="sx-view-btn" href="'+url+'" onclick="event.stopPropagation()">View Product</a>';}
else{ctaHtml=priceHtml+'<div class="sx-qty-note">1 qty = 1 strut</div><div class="sx-qty-row" onclick="event.stopPropagation();"><button class="sx-qty-btn sx-qty-minus" type="button">\u2212</button><div class="sx-qty-val">1</div><button class="sx-qty-btn sx-qty-plus" type="button">+</button></div><button type="button" class="sx-atc-btn" onclick="event.stopPropagation();">Add to Cart</button><div class="sx-view-row"><a class="sx-view-link" href="'+url+'" onclick="event.stopPropagation();">View details</a><button type="button" class="sx-share-icon-btn" title="Copy link to this product" aria-label="Copy link to this product" onclick="event.stopPropagation();sxShareProduct(this);"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg></button></div>';}
var card=document.createElement('div');card.className='sx-prod-card'+(isBracket?' sx-bracket':'')+(isExact?' sx-exact-match':'');
card.innerHTML='<div class="sx-prod-inner"><div class="sx-prod-img-wrap'+(ihold?' sx-img-wait':'')+'">'+sxImgTag(img,ihold,SX_FALLBACK_IMG)+'</div><div class="sx-prod-body"><div class="sx-prod-title">'+sxYearFirst(p.t)+'</div><div class="sx-prod-tags">'+tags+'</div></div><div class="sx-prod-cta">'+ctaHtml+'</div></div>';
if(isBracket)card.innerHTML+='<div class="sx-bracket-notice">\u26a0\ufe0f <strong>Bracket modification required</strong> - contact us before ordering.</div>';
var lrPattern=/\b(left|right|l\/h|r\/h|lh\b|rh\b|offside|nearside)/i;
if(!p.k&&lrPattern.test(p.t))card.innerHTML+='<div class="sx-lr-notice">\u2139\ufe0f <strong>This strut fits one side only.</strong> Left/Right is from the rear of the vehicle looking forward.</div>';
if(p.s){card.classList.add('sx-card-pending');var pendingLinks=card.querySelectorAll('.sx-atc-btn,.sx-view-btn');for(var pi=0;pi<pendingLinks.length;pi++){pendingLinks[pi].classList.add('sx-btn-pending');}}
card.addEventListener('click',function(){if(card.classList.contains('sx-card-pending'))return;window.location.href=url;});
/* THE PRICE ON THE CARD COMES FROM SHOPIFY, NOT FROM OUR DATA FILE.
   Found 13/09/2026, the day before launch: every vehicle listing showed
   $68.00 on the card and charged $75.00 in the cart. Not a trade price and
   not a discount - the cart reported total_discount 0 and SX_TRADE {pct:0}.

   The finder's product data comes from struxa-data-nz, one JSON per make,
   and its price field had gone stale at 68 across the WHOLE dataset:
   alfa-romeo 16 of 16, audi 124 of 124, bmw 188, toyota 77, ford 142,
   holden 32. Shopify says 75. So a customer browsing by vehicle - the way
   we tell people to shop - saw one price on the shelf and a 10% higher one
   at the till.

   Fixed by not trusting the file. sxResolveSku ALREADY calls Shopify's
   /search/suggest.json for every card that has a SKU, to resolve the
   product URL and image, and that response already carries the live price -
   it was simply being discarded. So this costs no extra request: the same
   call now also corrects the price.

   Deliberately not fixed by regenerating struxa-data-nz. A price copied
   into a static file drifts the moment prices move and nobody finds out
   until a customer does, which is exactly what happened here. Reading it
   from Shopify means it cannot happen twice.

   The file's price is still used as the FIRST PAINT so the card is not
   blank while the lookup is in flight; it is overwritten a moment later.
   data-sx-base is updated too, so the quantity buttons reprice off the
   real number rather than the stale one. */
if(p.s){sxResolveSku(p.s,function(res){card.classList.remove('sx-card-pending');var pl=card.querySelectorAll('.sx-btn-pending');for(var bi=0;bi<pl.length;bi++){pl[bi].classList.remove('sx-btn-pending');}if(!res){sxSetCardImg(card,null);sxMarkCardUnavailable(card);return;}if(res){url=res.url;var ls=card.querySelectorAll('.sx-view-btn,.sx-view-link');for(var i=0;i<ls.length;i++){ls[i].href=res.url;}var live=parseFloat(res.price);if(live>0){var pe=card.querySelector('.sx-prod-price');if(pe){pe.classList.remove('sx-price-pending');pe.setAttribute('data-sx-base',live);var qv=card.querySelector('.sx-qty-val');pe.innerHTML=sxPriceInner(live,parseInt(qv&&qv.textContent,10)||1);}}}sxSetCardImg(card,res&&res.img);});}
var minus=card.querySelector('.sx-qty-minus'),plus=card.querySelector('.sx-qty-plus'),qtyEl=card.querySelector('.sx-qty-val');
if(minus&&qtyEl)minus.addEventListener('click',function(e){e.stopPropagation();var v=parseInt(qtyEl.textContent)||1;if(v>1)qtyEl.textContent=v-1;sxRepriceCard(card,qtyEl);});
if(plus&&qtyEl)plus.addEventListener('click',function(e){e.stopPropagation();qtyEl.textContent=(parseInt(qtyEl.textContent)||1)+1;sxRepriceCard(card,qtyEl);});
var atcBtn=card.querySelector('.sx-atc-btn');
if(atcBtn)atcBtn.addEventListener('click',function(e){e.stopPropagation();sxAddToCart(atcBtn,function(){return url;},qtyEl);});
return card;
}
/* Struxa: navigator.share has to be called synchronously inside the click - it
   needs transient user activation, and iOS rejects it after any await. That
   rules out looking the sharer's referral code up at share time, so we warm it
   once (guests included: the lookup just answers null) and read the cached
   value at click time. Nothing waits on it; a share fired before it lands goes
   out as a plain product link, which is what it was before this existed. */
var SX_REF_CODE=null;
function sxWarmRefCode(){
if(SX_REF_CODE!==null)return;
SX_REF_CODE='';
if(!(window.StruxaShare&&window.StruxaShare.getOwnReferralCode))return;
window.StruxaShare.getOwnReferralCode().then(function(c){SX_REF_CODE=c||'';},function(){SX_REF_CODE='';});
}
function sxRefShareUrl(url){
if(!SX_REF_CODE||window.SX_REF_SHARE_OPTOUT)return url;
if(!(window.StruxaShare&&window.StruxaShare.withReferralCode))return url;
return window.StruxaShare.withReferralCode(url,SX_REF_CODE);
}
window.sxShareProduct=function(btn){
var card=btn.closest('.sx-prod-card');
var link=card&&(card.querySelector('.sx-view-btn')||card.querySelector('.sx-view-link'));
var shareUrl=link?link.href.split('?')[0]:window.location.href;
var titleEl=card&&card.querySelector('.sx-prod-title');
var title=titleEl?(titleEl.textContent||'').trim():document.title;
/* Struxa: the confirmation used to wait on the copy, and the copy waits on the
   /apps/rewards/me referral lookup - so the icon sat unchanged for a second or
   two after a click that had already worked. Paint the confirmed state FIRST
   and only walk it back if the copy really fails. */
function mark(ok){
btn.style.color=ok?'#ff7a00':'#c0392b';
btn.title=ok?'Link copied!':'Could not copy - try again';
if(btn.__sxShareT)clearTimeout(btn.__sxShareT);
btn.__sxShareT=setTimeout(function(){btn.style.color='';btn.title='Copy link to this product';},1500);
}
function copyFallback(){
mark(true);
var url=sxRefShareUrl(shareUrl);
if(window.StruxaShare&&window.StruxaShare.copyToClipboard){
window.StruxaShare.copyToClipboard(url).catch(function(){mark(false);});
}else if(navigator.clipboard&&navigator.clipboard.writeText){
navigator.clipboard.writeText(url).catch(function(){mark(false);});
}else{
try{
var ta=document.createElement('textarea');ta.value=url;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();
if(!document.execCommand('copy'))mark(false);
document.body.removeChild(ta);
}catch(err){mark(false);}
}
}
/* Phones and tablets get their own share sheet (Messages, WhatsApp, AirDrop).
   No "Link copied!" on this path - the sheet IS the feedback. An AbortError is
   the customer closing the sheet, not a failure, so it stays silent. */
if(navigator.share){
try{
var res=navigator.share({title:title,text:'Gas strut from Struxa - '+title,url:sxRefShareUrl(shareUrl)});
if(res&&res.then){res.then(null,function(err){if(err&&err.name==='AbortError')return;copyFallback();});}
return;
}catch(e){}
}
copyFallback();
};

/* Mirrors decorate() in assets/sx-fit-assurance.js. Returns {} when nothing is
   known, which is correct - an empty properties object adds nothing. */
function sxFitProps(sku){
  var props = {};
  try {
    var m = window.sxFit && window.sxFit.get && window.sxFit.get();

    /* NO MATCH, NO CLAIM. sxFit.tierFor() returns 2 for "partial match" AND 2
       for "nothing was ever matched" - `if (!m) return 2` - so the tier alone
       cannot tell the two apart. This used to claim a tier whenever sxFit
       existed, which meant a line added after a cleared or failed match
       carried "Partial match - force rating not confirmed" about a vehicle
       nobody had identified. A fitment promise about nothing.

       Narrowed 10/09/2026 to match stxCartProps() in
       snippets/sx-label-scanner.liquid, where the same hole was found first.
       The two must stay in step: they write the same property names into the
       same cart. */
    if (!m) return props;

    var tier = window.sxFit.tierFor(sku);
    /* Only a CONFIRMED match gets a customer-visible property. A partial match
       records the same sentence under an underscore name, which Shopify and the
       printing apps treat as internal - it stays on the order in admin and
       appears on nothing the customer receives. Dave, 14/09/2026, after finding
       it on the #1006 tax invoice. Keep in step with assets/sx-fit-assurance.js
       and snippets/sx-label-scanner.liquid. */
    if (tier === 1) {
      props['Fit Assurance'] = '100% match - guaranteed fitment';
    } else {
      props['_fit_note'] = 'Partial match - force rating not confirmed';
    }
    props['_fit_tier'] = String(tier);
    if (m.vehicle) props['Vehicle'] = m.vehicle;
    if (m.source)  props['_fit_source'] = m.source;
    if (m.plate)   props['_fit_plate'] = String(m.plate).toUpperCase();
    if (m.code)    props['_fit_code'] = m.code;
  } catch (e) { return props; }
  return props;
}

window.sxAddToCart=function(btn,getUrl,qtyElArg){
var purl=getUrl();
var qty=parseInt(qtyElArg&&qtyElArg.textContent)||1;
var origText=btn.textContent;
btn.disabled=true;btn.textContent='Adding\u2026';
fetch(purl+'.js').then(function(r){return r.json();}).then(function(prod){
var vid=prod&&prod.variants&&prod.variants[0]&&prod.variants[0].id;
if(!vid)throw new Error('no-variant');
/* Struxa: this add-to-cart bypasses the product form, so it also bypassed
   sx-fit-assurance.js, which decorates that form. Result: a strut bought from
   a finder card carried NO Fit Assurance at all - on the surface most
   customers actually use. Build the same properties here from window.sxFit.
   Names must stay identical to decorate() in assets/sx-fit-assurance.js, or
   the cart summary and the order emails will not see them. */
return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:vid,quantity:qty,properties:sxFitProps(prod&&prod.variants&&prod.variants[0]&&prod.variants[0].sku)}],sections:'cart-drawer,cart-icon-bubble',sections_url:window.location.pathname})});
}).then(function(r){return r.json();}).then(function(data){
if(data&&data.status)throw new Error(data.description||'cart-error');
var cd=document.querySelector('cart-drawer');
if(cd&&cd.renderContents){if(cd.setActiveElement)cd.setActiveElement(document.activeElement);cd.renderContents(data);}
btn.textContent='Added \u2713';
}).catch(function(){
window.location.href=purl;
}).finally(function(){
setTimeout(function(){btn.disabled=false;btn.textContent=origText;},1500);
});
};
window.sxVfSearch=function(skipRego){
var inp=document.getElementById('sx-model-inp');if(!inp)return;
var v=inp.value.trim();if(!v)return;
var vl=v.toLowerCase();
var exactMake=SX_MAKES.find(function(x){return x.toLowerCase()===vl;});
if(exactMake){sxVfPickMake(exactMake);return;}
var words=vl.split(/\s+/);
if(words.length>=2){
var mm=SX_MAKES.find(function(x){return x.toLowerCase()===words[0];});
if(!mm)mm=SX_MAKES.find(function(x){return x.toLowerCase().indexOf(words[0])>=0;});
if(mm){sxVfPickMake(mm);sxLoadMake(mm,function(){var modelQ=words.slice(1).join(' ');var mods=Object.keys(SX_VD[mm]).filter(function(m){return m!=='_misc'&&m!=='_loaded'&&m!=='_count'&&m.toLowerCase().indexOf(modelQ)>=0;});if(mods.length===1){sxVfPickMod(mods[0]);}else{var mf=document.getElementById('sx-model-filter');if(mf)mf.value=modelQ;sxRenderModels(modelQ);}});return;}
}
var partialMake=SX_MAKES.find(function(x){return x.toLowerCase().startsWith(vl);});
if(partialMake){sxVfPickMake(partialMake);return;}
var foundMake=null;
SX_MAKES.forEach(function(mk){if(foundMake||!SX_VD[mk]||!SX_VD[mk]._loaded)return;if(Object.keys(SX_VD[mk]).some(function(m){return m!=='_misc'&&m!=='_loaded'&&m!=='_count'&&m.toLowerCase().indexOf(vl)>=0;}))foundMake=mk;});
if(foundMake){sxVfPickMake(foundMake);setTimeout(function(){var mf=document.getElementById('sx-model-filter');if(mf)mf.value=vl;sxRenderModels(vl);},150);return;}
sxRenderMakes(v);
};
window.sxVfNavBack=function(){
if(SX_VF.mod!==null){SX_VF.mod=null;sxRenderModels();sxPanel('pm');}
else{sxVfReset();}
};
window.sxVfReset=function(){
SX_VF.make=null;SX_VF.mod=null;SX_VF.regoFilter=null;SX_VF.plate=null;SX_VF._regoLogged=null;sxVfRegoBusy(false);
var mi=document.getElementById('sx-model-inp');if(mi)mi.value='';
var ri=document.getElementById('sx-rego-inp');if(ri)ri.value='';
var hi=document.getElementById('sx-rego-hint');if(hi)hi.textContent='';
var vi=document.getElementById('sx-vehicle-badge');if(vi)vi.remove();
var nf=document.getElementById('sx-not-found');if(nf)nf.remove();
var yf=document.getElementById('sx-year-filter');if(yf)yf.remove();
sxStatusHide();sxRenderMakes();sxPanel('pp');
};
window.sxVfFillContact=function(productOrMsg,plate){
var c=document.getElementById('sx-contact');if(!c)return;
c.scrollIntoView({behavior:'smooth',block:'start'});
setTimeout(function(){
var msg=document.getElementById('sx-cf-msg');
if(msg&&!msg.value)msg.value=productOrMsg?'Hi, I need help with: '+productOrMsg:'Hi, I need help finding gas struts for my vehicle.';
var regoInp=document.getElementById('sx-cf-rego');
if(regoInp&&(plate||SX_VF.plate)&&!regoInp.value)regoInp.value=plate||SX_VF.plate;
},600);
};
window.sxVfContactSubmit=function(e){
e.preventDefault();
var btn=document.querySelector('#sx-contact-form .sx-contact-submit');
if(btn){btn.textContent='Sending\u2026';btn.disabled=true;}
var name=document.getElementById('sx-cf-name').value;
var email=document.getElementById('sx-cf-email').value;
var phone=document.getElementById('sx-cf-phone').value;
var rego=document.getElementById('sx-cf-rego').value;
var msg=document.getElementById('sx-cf-msg').value;
var subject=encodeURIComponent('Struxa Vehicle Gas Strut Enquiry'+(rego?' - '+rego:''));
var body=encodeURIComponent('Name: '+name+'\nEmail: '+email+'\nPhone: '+phone+'\nRego: '+rego+'\n\n'+msg);
setTimeout(function(){
var success=document.getElementById('sx-cf-success');if(success)success.style.display='block';
if(btn){btn.textContent='\uD83D\uDCE7 Send Message';btn.disabled=false;}
window.location.href='mailto:info@struxamotion.com?subject='+subject+'&body='+body;
},500);
};
function sxFetch(url,cb){
var xhr=new XMLHttpRequest();
/* A STABLE token, not Date.now(). See SX_DATA_VER above: a unique URL
   per request meant the data host's 24-hour cache header was never
   once honoured, and the all-makes warm-up re-pulled 629 KB on every
   page view. Bump SX_DATA_VER to force every cached copy to refresh. */
xhr.open('GET',url+'?v='+sxDataToken(),true);xhr.timeout=15000;
xhr.onload=function(){if(xhr.status===200){try{cb(null,JSON.parse(xhr.responseText));}catch(e){cb(e);}}else{cb(new Error('HTTP '+xhr.status));}};
xhr.onerror=function(){cb(new Error('Network error'));};
xhr.ontimeout=function(){cb(new Error('Timeout'));};
xhr.send();
}
function sxLoadMake(mk,cb){
if(SX_VD[mk]&&SX_VD[mk]._loaded){cb();return;}
var slug=mk.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
sxFetch(SX_DATA_BASE+slug+'.json',function(err,data){
if(err){cb(err);return;}
SX_VD[mk]=sxShapeMakeData(mk,data);SX_VD[mk]._loaded=true;sxRefreshMakeCount(mk);cb();
});
}
/* Struxa: the makes grid renders before the per-make data arrives, so every
   tile shows a number from the static table above. Once a make actually loads
   we know the truth - patch that tile, and any virtual tile it feeds, in
   place. Updating the text beats re-rendering the grid: no flicker, and the
   customer's scroll position survives. */
function sxRefreshMakeCount(mk){
try{
var grid=document.getElementById('sx-makes-grid');if(!grid)return;
function liveCount(name){
var v=SX_VD[name];if(!v)return null;
if(v._loaded)return Object.values(v).filter(function(x){return Array.isArray(x);}).reduce(function(a,b){return a+b.length;},0);
return typeof v._count==='number'?v._count:null;
}
function paint(name,n){
if(n===null)return;
var cards=grid.querySelectorAll('.sx-make-card');
for(var i=0;i<cards.length;i++){
var nm=cards[i].querySelector('.sx-make-name');
if(nm&&nm.textContent===name){
var c=cards[i].querySelector('.sx-make-count');
if(c)c.textContent=n+(n===1?' product':' products');
return;
}
}
}
paint(mk,liveCount(mk));
Object.keys(SX_VIRTUAL_MAKES).forEach(function(vm){
if(SX_VIRTUAL_MAKES[vm].indexOf(mk)<0)return;
var total=SX_VIRTUAL_MAKES[vm].reduce(function(sum,src){var n=liveCount(src);return sum+(n||0);},0);
paint(vm,total);
});
}catch(e){}
}
function sxShapeMakeData(mk,raw){return window.__sxShape(mk,raw);}
function sxInjectRegoSteps(){
if(document.getElementById('sx-rego-steps'))return;
var panel=document.getElementById('sx-rego-panel');if(!panel)return;
var bar=document.createElement('div');bar.id='sx-rego-steps';bar.className='sx-steps-bar';
bar.innerHTML='<div class="sx-step-tile"><div class="sx-step-num">1</div><span class="sx-step-title">Enter your rego</span><span class="sx-step-desc">Type your plate number above</span></div>'
+'<div class="sx-step-tile"><div class="sx-step-num">2</div><span class="sx-step-title">We look up your car</span><span class="sx-step-desc">Instant vehicle register lookup</span></div>'
+'<div class="sx-step-tile"><div class="sx-step-num">3</div><span class="sx-step-title">See matching struts</span><span class="sx-step-desc">View & buy the right ones</span></div>';
panel.appendChild(bar);
}
function sxInjectModelSteps(){
if(document.getElementById('sx-model-steps'))return;
var panel=document.getElementById('sx-model-panel');if(!panel)return;
var bar=document.createElement('div');bar.id='sx-model-steps';bar.className='sx-steps-bar';
bar.innerHTML='<div class="sx-step-tile"><div class="sx-step-num">1</div><span class="sx-step-title">Select your make</span><span class="sx-step-desc">Browse all vehicle makes below</span></div>'
+'<div class="sx-step-tile"><div class="sx-step-num">2</div><span class="sx-step-title">Select your model</span><span class="sx-step-desc">Filter by year range and variant</span></div>'
+'<div class="sx-step-tile"><div class="sx-step-num">3</div><span class="sx-step-title">Add to cart</span><span class="sx-step-desc">OEM-match struts shipped fast</span></div>';
panel.appendChild(bar);
}
/* Struxa: these are the pre-load counts shown on a make tile before that
   make's JSON arrives. The previous table was a stale snapshot and badly
   wrong - BMW read 68 against a real 188, Saab 3 against 20, Porsche 8
   against 38 - and it keyed Kia as "KIA", which does not match the make
   name, so Kia's tile showed 0 until its data loaded. Regenerated from the
   live catalogue on 2026-08-26: 59 makes, 1983 products.
   Tiles now also self-correct as each make loads (see sxLoadMake), so a
   stale entry here is cosmetic and short-lived rather than sticky. */
var SX_PROD_COUNTS = {
"Alfa Romeo":16,"Arb":2,"Audi":122,"Austin":3,"BMW":152,"Back":2,
"Brahma":1,"Chevrolet":19,"Chrysler":5,"Citroen":54,"Crown":3,"Dacia":23,
"Daewoo":10,"Daihatsu":4,"Dale":1,"Dodge":18,"Explorer":1,"Fiat":62,
"Ford":141,"Holden":32,"Honda":19,"Hyundai":81,"Infiniti":43,"Isuzu":2,
"Jaguar":24,"Jeep":13,"Kia":65,"Lada":8,"Lancia":13,"Land Rover":27,
"Lexus":20,"Lotus":8,"Mazda":27,"Mercedes-Benz":60,"Mini":18,"Mitsubishi":32,
"Nissan":54,"Opel":99,"Peugeot":67,"Pontiac":1,"Porsche":38,"Range Rover":3,
"Renault":86,"Rexton":2,"Rover":3,"Saab":20,"Seat":34,"Skoda":46,
"Smart":10,"SsangYong":7,"Subaru":8,"Suzuki":18,"Taylor":2,"Tesla":1,
"Toyota":77,"Tuff":1,"Vauxhall":14,"Volkswagen":128,"Volvo":90
}
window.SX_GSCAT = null;
window.SX_SC_STREAM = null;
window.SX_SC_AI_RUNNING = false;
window.SX_REGO_PRODS = [];
/* Struxa: ?q= used to be classified here with /^[a-zA-Z0-9]{2,7}$/ - which
   matches "toyota", so a make search was posted to the rego lookup and came
   back "no vehicle found". Classification now lives in one place,
   assets/sx-search-router.js, shared with the search box at the top of every
   page. If that asset has not loaded, fall back to the old shape test but
   check the makes list first, so at least a make never goes to the rego tab. */
function sxVfIsRego(q){
q=(q||'').trim();
if(!q)return false;
if(window.sxSearchClassify){
var t=window.sxSearchClassify(q).type;
/* 'ambiguous' is a letters-only string the shop has no product for - on this
   page that is a personalised plate (ETHICL, BIGFLA), so treat it as a rego. */
return t==='rego'||t==='ambiguous';
}
if(q.indexOf(' ')>-1)return false;
var lower=q.toLowerCase();
for(var i=0;i<SX_MAKES.length;i++){if(SX_MAKES[i].toLowerCase()===lower)return false;}
return /^[a-zA-Z0-9]{2,7}$/.test(q);
}

/* Open the finder on whatever the customer actually typed - rego lookup for a
   plate, make/model browse for anything else. Used by ?q= and by the rego box
   itself, so typing "toyota" into the rego field does the sensible thing
   instead of failing a plate lookup. */
window.sxVfOpenQuery=function(q){
q=(q||'').trim();
if(!q)return;
if(sxVfIsRego(q)){
sxVfSwitchTab('rego');
var ri2=document.getElementById('sx-rego-inp');if(ri2)ri2.value=q.toUpperCase();
var tries=0;
var wait=setInterval(function(){
if(SX_MAKES.length>0){clearInterval(wait);sxVfSearchRego();return;}
if(++tries>120)clearInterval(wait);
},100);
return;
}
sxVfSwitchTab('model');
var mi2=document.getElementById('sx-model-inp');if(mi2)mi2.value=q;
setTimeout(function(){sxVfSearch(true);},200);
};

function sxVfInit(){
var grid=document.getElementById('sx-makes-grid');
if(!grid){setTimeout(sxVfInit,100);return;}
var ri=document.getElementById('sx-rego-inp');
if(ri){ri.addEventListener('keydown',function(e){if(e.key==='Enter')sxVfSearchRego();});ri.addEventListener('input',function(){this.value=this.value.toUpperCase();});}
var mi=document.getElementById('sx-model-inp');
if(mi){mi.addEventListener('input',function(){var v=this.value.trim();if(!v){sxRenderMakes();sxPanel('pp');}else{sxRenderMakes(v);}});mi.addEventListener('keydown',function(e){if(e.key==='Enter')sxVfSearch(true);});}
grid.innerHTML='<div style="padding:20px;color:var(--muted);font-size:13px;text-align:center">Loading vehicles\u2026</div>';
sxFetch(SX_DATA_BASE+'index.json',function(err,data){
if(err){
grid.innerHTML='<div style="padding:20px;color:#f87171;text-align:center">Could not load vehicle data.<br><button style="margin-top:8px;padding:6px 14px;background:var(--orange);color:#fff;border:none;border-radius:6px;cursor:pointer;font-family:var(--display);" onclick="sxVfInit()">Retry</button></div>';
return;
}
SX_MAKES=Object.keys(data).sort();
SX_VD={};
SX_MAKES.forEach(function(mk){SX_VD[mk]={_count:SX_PROD_COUNTS[mk]||data[mk]||0,_loaded:false};});
['Canopy','Other'].forEach(function(vm){if(!SX_VD[vm]){SX_VD[vm]={_loaded:false,_count:0};SX_VIRTUAL_MAKES[vm].forEach(function(src){SX_VD[vm]._count+=(SX_PROD_COUNTS[src]||0);});}});
sxRenderMakes();
sxPanel('pp');
sxInjectRegoSteps();
sxInjectModelSteps();
var urlParams=new URLSearchParams(window.location.search);
var qParam=urlParams.get('q');
if(qParam){sxVfOpenQuery(qParam);}
/* Struxa: open straight onto a make, or a make and model, from the URL.
   /pages/vehicle-store?make=toyota&model=corolla
   Lets the model collections link into the store so the customer arrives
   at the rego lookup already filtered to their vehicle. No parameters
   means this whole block is skipped and behaviour is unchanged. */
var makeParam=urlParams.get('make');
var modelParam=urlParams.get('model');
if(makeParam){
var wanted=makeParam.toLowerCase().trim();
var pool=SX_MAKES.concat(Object.keys(SX_VIRTUAL_MAKES));
var mk=pool.filter(function(m){return m.toLowerCase()===wanted;})[0]
     ||pool.filter(function(m){return m.toLowerCase().indexOf(wanted)===0;})[0];
if(mk){
sxVfPickMake(mk);
if(modelParam){
var wantMod=modelParam.toLowerCase().trim();
sxLoadMake(mk,function(){
/* Groups first. The list the customer clicks shows '__group__Corolla'
   (16 products), not the bare 'Corolla' model (5). */
var groups=(typeof sxGetGroups==='function')?(sxGetGroups(mk)||{}):{};
var gN=Object.keys(groups);
var mods=Object.keys(SX_VD[mk]||{}).filter(function(m){
return m!=='_loaded'&&m!=='_count'&&m!=='_misc';});
var g=gN.filter(function(x){return x.toLowerCase()===wantMod;})[0];
if(g){sxVfPickMod('__group__'+g);return;}
var r=mods.filter(function(m){return m.toLowerCase()===wantMod;})[0];
if(r){sxVfPickMod(r);return;}
g=gN.filter(function(x){return x.toLowerCase().indexOf(wantMod)===0;})[0];
if(g){sxVfPickMod('__group__'+g);return;}
r=mods.filter(function(m){return m.toLowerCase().indexOf(wantMod)===0;})[0];
if(r){sxVfPickMod(r);return;}
sxRenderModels();
});
}
}
}
var contactParam=urlParams.get('contact');
if(contactParam){setTimeout(function(){sxVfFillContact(decodeURIComponent(contactParam));},500);}
setTimeout(function(){if(typeof sxScLoadCatalogue==='function')sxScLoadCatalogue();},1000);
var i=0;
function next(){if(i>=SX_MAKES.length)return;sxLoadMake(SX_MAKES[i++],function(){setTimeout(next,60);});}
setTimeout(next,800);
});
}
if(document.readyState!=='loading'){sxVfInit();}
else{document.addEventListener('DOMContentLoaded',sxVfInit);}
})();
